import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import TimePicker from 'rc-time-picker';
import Moment from 'moment';
import { SingleDatePicker } from 'react-dates';

import Sticky from 'Components/Sticky';
import Upload from 'Components/Upload';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import SeekerBidsTable from 'Components/SeekerBidsTable';
import ChallengePriceTooltip from 'Components/ChallengePriceTooltip';
import ClickOutside from 'Components/ClickOutside';
import ConfirmationRemarksPopup from 'Components/ConfirmationRemarksPopup';
import ApproverConfirmationPopup from 'Components/ApproverConfirmationPopup';
import Chat from 'Containers/Chat';
import Timer from 'Components/Timer';
import ActionLoader from 'Components/ActionLoader';
import ReactTooltip from 'react-tooltip';

import { FETCH_SEEKER_BIDS, CHALLENGE_PRICE, SEND_LOI, CHANGE_BID_END, ADD_LOI_APPROVER, SEND_APPROVER_LOI_MESSAGE, CLEAR_FETCH_SEEKER_BIDS, UPLOAD_BIDDING_DETAILS, DOWNLOAD_BIDDING_DETAILS, GET_LPP_DETAILS, CHANGE_TRIP_BID_END, CANCEL_RFQ, COUNTER_PRICE_FOR_SEEKER, DELETE_TRIP_DETAILS, OTHER_COST_CHALLENGE_PRICE, DOWNLOAD_BIDDING_TRAIL, FETCH_BIDS, GET_ZONES, GET_MOVEMENTS, GET_MODES, GET_TRANSPORTER_BID_COMMON_CHARGES, GET_IP_ADDRESS, GET_CURRENCY_DETAILS, DOWNLOAD_BIDDING_RATE, UPLOAD_BIDDING_RATE, DOWNLOAD_TRUCKS, UPLOAD_NUMBER_OF_TRUCKS, NUMBER_OF_VEHICLE_PLACED, GET_CURRENCY_TYPES, CLOSED_RFQ, ACCEPTANCE_CEILING_PRICE, REVOKE_WITHDRAW_BID, GET_VEHICLE_TYPES, POST_SHARE_OF_BUSINESS, UPDATE_DPH_DETAILS, TRIP_LEVEL_CONTRACT_EXTENSION, TRIP_LEVEL_BID_EXTENSION, POST_REJECT_LOI_FROM_APPROVER, POST_DPH_APPROVAL, POST_APPROVE_DPH, RETRIGGER_TK11_FOR_RFQ, UPLOAD_SOB_DETAILS, DOWNLOAD_SOB_TEMPLATE, UPLOAD_OFFLINE_SLABEWISE_TRIPS, DOWNLOAD_OFFLINE_SLABEWISE_TRIPS, GET_GROUPS_AND_TRANSPORTERS, ADD_ADDITIONAL_TRANSPORTER_DURING_BIDDING, GET_RFQ_LEVEL_PR_DETAILS, GET_TRANSPORTER_LEVEL_PR_DETAILS, DOWNLOAD_PR_DETAILS, GET_SEEKER_TRANSPORTERS, UPDATE_RFQ_LEVEL_VENDOR_BIDDING_STATUS, GET_OTHER_CHARGES_TEMPLATE, UPLOAD_OTHER_CHARGES, UPDATE_POST_BID_TO_PRE_BID_RFQ, UPLOAD_DOCUMENT, DOWNLOAD_UPLOADED_FILE, GET_OFFLINE_CONTRACTS_DETAILS_TO_UPDATE, POST_OFFLINE_CONTRACTS_UPDATED_DETAILS, EXTEND_BID_TIME_FOR_SINGLE_BIDDED_TRIPS, REACTIVATE_TK11, CANCEL_CP, POST_TOLL_TAX_UPDATE_PRICE, GET_BUSINESS_VOLUMES, POST_UPDATE_BUSINESS_VOLUME} from 'Constants/actionConstants';
import { SEEKER, RFQ_DISPLAY_LIMIT, HIKAL, EMAMI, CARGIL, ROQUETTE, STAR_CEMENT, POLYCAB, BEAM, DEEPAK_PHENOLICS_SAP, DEEPAK_PHENOLICS, RAJPETRO, AWL, COROMANDEL, VISHAKA } from 'Constants/commonConstants';

import { ReactComponent as CancelIcon } from 'Icons/closeFilled.svg'
import { ReactComponent as OpenIcon } from 'Icons/open.svg';
import { ReactComponent as BackIcon } from 'Icons/back.svg';
import { ReactComponent as CloseIcon } from 'Icons/close-circle.svg';
import { CLEAR_RFQ_DETAIL } from 'Constants/actionConstants';

import { getUser, getDashboardActiveView, getCookie } from 'Utils/storage';

import classNames from 'classnames';
import { TOAST_ERROR } from 'Constants/actionConstants';
import rfq from 'Reducers/rfq';
import Loader from "Components/ActionLoader/LoaderWithBlur";
import DPHUpdate from "Pages/Contracting/updateDPH";
import ExtendContrcatTenure from './ExtendContractTenure';
import { numberWithCommas, downloadUrl } from 'Utils';
import { isAdaniWilmar, isBeamS, isCoromandel, isDesmet, isFosroc, isHikal, isVishaka} from 'Utils/index';
import LoiConfirmationPopup from './LoiConfimationpopup';
import Overlay from 'Components/Overlay';
import TransportersCard from 'Components/TransportersCard';
import Heading from 'Components/Heading';
import PRDetailsPopup from 'Components/PRDetailsPopup';
import UpdateStatusVisibility from './UpdateStatusVisibility';
import PreBidPopup from './preBidPopup';
import ViewUploadedFiles from './ViewUploadedFiles';
import Pdf from "react-to-pdf";
import PRFormat from "Components/PRFormat";
import ScreenTimeTrack from "Components/Common/ScreenTimeTrack/index";
import { screenInfoDetails } from 'Constants/screenInfoDetailsConstants';
import RfqTollUpdatePrice from './RfqTollUpdatePrice';
import { MdContentCopy, MdCheck } from "react-icons/md";
import UpdateBusinessVolume from './UpdateBusinessVolume';

const pdfRef = React.createRef();
class RFQBids extends Component {
	state = {
		isChallengePriceShown: false,
		selectedBids: [],
		biddingEnd: this.props.rfq ? Moment(this.props.rfq.rfqDetails.biddingEnd) : (this.props.systemTime || new Date().getTime()),
		isTimerShown: true,
		isRFQDetailsShown: false,
		remarks: "",
		instructions: "",
		acceptLoiFrom: (this.props.systemTime || new Date().getTime()),
		acceptLoiTo: this.props.systemTime && Moment(this.props.systemTime).add(2, 'hours') || new Date().setHours(new Date().getHours() + 2),
		focusedFrom: false,
		focusedTo: false,
		isChangeSpecificBidShown: false,
		showCancelPopup: false,
		isSentLOiApproverDisable: false,
		approverLoiRemarks: "",
		errorMessage: "",
		approverMsg: null,
		loiWithCPPrice: false,
		cpPrice: 0,
		updatedRateFile :"",
		isTruckUpload: false,
		updatedNumberOfTruckFile :"",
		isClosedRfqPopUp: false,
		sobList: [],
		selectedTrip: [],
		loi_docs: [],
		isRfqCopied: false,
		isSendApproverPopupShown: false,
		loiActionType: null,
		updateBusinessVolume:false,
		businessVolume: {
			value: '',
			unit: null,
			name: ''
		},
	}
	isApprovalMode = this.props.match.path === '/seeker/bids/:id/approval'

	loiApproverType = this.props.location.state && this.props.location.state.dashboardActiveView ? this.props.location.state.dashboardActiveView : getDashboardActiveView();

	seekerBidsTimer = null;

	toggleRFQDetails = () => {
		this.setState({
			isRFQDetailsShown: !this.state.isRFQDetailsShown
		})
	}
	showChallengePrice = () => {
		this.setState({
			isChallengePriceShown: true
		})
	}
	hideChallengePrice = () => {
		this.setState({
			isChallengePriceShown: false
		});
	}

	showLoiPopup = () => {
		const { rfq } = this.props;
		let { selectedBids } = this.state;
		const dashboardActivestatus = this.props.location.state && this.props.location.state.dashboardActiveView ? this.props.location.state.dashboardActiveView : getDashboardActiveView();
		const isEmamiCompleteSolution = ([...EMAMI].includes(getUser().companyId) && rfq && !rfq.rfqDetails.acceptPartialSolution);
		// const isCargil = CARGIL.includes(getUser().companyId);
		if((isEmamiCompleteSolution) && this.state.showConfirmationPopup) {
			this.setState({
				showConfirmationPopup: false
			});
			return;
		}
		// if((isAdaniWilmar() && !getUser().is_rlm_user && (selectedBids || []).filter(el => el.orderText !== 'L1' && !el.isAccept).length > 0) || (isEmamiCompleteSolution && (selectedBids || []).filter(el => selectedBids[0].transporterId !== el.transporterId && !el.isAccept).length > 0)) {
		if((isEmamiCompleteSolution && (selectedBids || []).filter(el => selectedBids[0].transporterId !== el.transporterId && !el.isAccept).length > 0)) {
			if(!isEmamiCompleteSolution) {
				selectedBids = selectedBids.filter(el => el.orderText === 'L1');
			}
			this.setState({
				showConfirmationPopup: true,
				selectedBids
			});
			return;
		}
		// if(isCargil && (selectedBids || []).filter(el => !el.additional_cost).length > 0) {
		// 	this.setState({
		// 		showConfirmationPopup: true,
		// 		selectedBids
		// 	});
		// 	return;
		// }
		if((selectedBids || []).length === 0) {
			this.setState({
				showConfirmationPopup: false
			});
			return;
		}
		if(rfq.shareOfBusiness && ![10,12,13].includes(dashboardActivestatus)) {
			const lessAllocatedBids = (selectedBids || []).filter(el => el.sumOfSOB < 100);
			if(lessAllocatedBids.length > 1) {
				this.setState({
					sobAllocationPopUp: true,
					loiApprover: false
				})
			} else {
				this.loiPopupDetails();
			}
		} else {
			this.loiPopupDetails();
		}
	}

	handleCopyRfqNumber = () => {
		const { rfq } = this.props;

		if (!rfq?.rfqNumber) return;

		navigator.clipboard.writeText(rfq.rfqNumber).then(() => {
			this.setState({ isRfqCopied: true });

			setTimeout(() => {
				this.setState({ isRfqCopied: false });
			}, 1500);
		});
	};


	loiPopupDetails = () => {
		const { rfq, systemTime } = this.props;
		let { acceptLoiFrom, acceptLoiTo, selectedBids } = this.state;
		if (rfq && rfq.loiPeriodApplicable && rfq.loiAcceptancePeriod) {
			const getTimeToAdd = (rfq.loiAcceptancePeriod) && rfq.loiAcceptancePeriod.split(':');
			acceptLoiFrom = systemTime || new Date();
			acceptLoiTo = systemTime && Moment(this.props.systemTime).add(+getTimeToAdd[0], 'hours') || new Date().setHours(new Date().getHours() + (+getTimeToAdd[0]));
			acceptLoiTo = systemTime ? Moment(acceptLoiTo).add(+getTimeToAdd[1], 'minutes') : new Date().setHours(new Date().getMinutes() + (+getTimeToAdd[1]));
		} else {
			acceptLoiFrom = (this.props.systemTime || new Date().getTime());
			acceptLoiTo = this.props.systemTime && Moment(this.props.systemTime).add(2, 'hours') || new Date().setHours(new Date().getHours() + 2);
		}
		let loiTOSent = true;
		const dashboardActivestatus = this.props.location.state && this.props.location.state.dashboardActiveView ? this.props.location.state.dashboardActiveView : getDashboardActiveView();
		if(rfq.shareOfBusiness && ![10,12,13].includes(dashboardActivestatus)) {
			let isBidPresent = [];
			(selectedBids || []).forEach(bid =>{
				const { sobList } = this.state;
				const sobBid = (sobList || []).find(sBid => sBid.tripId === bid.tripId);
				if(bid.share_of_business_percentage && (sobBid ? sobBid.sumOfSOB == 100 : bid.sumOfSOB == 100)) {
					isBidPresent.push(bid);
				}
			});
			if(isBidPresent.length === 0) {
				loiTOSent = false;
			}
		}
		this.setState({
			isLoiPopupShown: loiTOSent,
			acceptLoiFrom,
			acceptLoiTo,
			sobAllocationPopUp: false,
			showConfirmationPopup: false
		});
	}

	hideSendLoiPoup = () => {
		this.setState({
			isSendApproverPopupShown: false
		});
	}

	openSendLoiApproverPopup = () => {
		this.setState({
			isSendApproverPopupShown: true,
			loiActionType: 'SEND_LOI_APPROVER'
		});
	};

	showLoiApproverPopup = (type) => {
		this.setState({
			isLoiApproverPopupShown: true,
			loiApproverPopupType: type 
		})
	}

	hideLoiApproverPoup = () => {
		this.setState({
			isLoiApproverPopupShown: false,
			loiApproverPopupType: ''
		});
	}
	hideLoiPoup = () => {
		this.setState({
			isLoiPopupShown: false
		});
	}
	sendLoi = () => {
		const { dispatch, match, rfq } = this.props;
		const rfqType = match.params.type && Number(match.params.type);
		const isRoquette = ROQUETTE.includes(getUser().companyId);
		const user = getUser();
		if (this.state.loiWithCPPrice === true) {
			if (this.state.cpPrice === '' || this.state.cpPrice === 0.0) {
				alert("Enter Challenge Price");
				return;
			}
		}

		const dashboardActivestatus = this.props.location.state && this.props.location.state.dashboardActiveView ? this.props.location.state.dashboardActiveView : getDashboardActiveView();
		const data = {
			rfq_id: match.params.id,
			rfqType,
			ip_address: localStorage.getItem('IPAddress'),
			loi_with_cp_price: this.state.loiWithCPPrice,
			is_approver: this.isApprovalMode ? true : undefined,
			is_approver_type: (this.loiApproverType === 10) ? this.loiApproverType : 0,
			is_average_lpp_approval: rfq.is_average_lpp_approval,
			is_percentage_base_approval: rfq.is_percentage_base_approval,
			loi_docs: this.state.loi_docs,
			loi_list: this.state.selectedBids.filter((bid) => {
				return (isRoquette ? true : !bid.isAccept) && bid.tripId && !bid.isWithDrawBid && (rfq.enableRoundBidding ? bid.trip_closed : true) && ((rfq.shareOfBusiness && ![10,12,13].includes(dashboardActivestatus)) ? (bid.share_of_business_percentage && bid.sumOfSOB == 100) : true);
			}).map((bid) => {
				console.log('bid', bid);
				const data = {
					trip_id: bid.tripId,
					transporter_id: bid.transporterId,
					company_id: (rfqType === 6) ? bid.providerType :((rfqType == 9) ? 24 : 2),
					is_approver: this.isApprovalMode,
					liner_id: bid.liner_id,
					business_volume: rfq.is_average_lpp_approval ? ([1, 9].includes(((bid.tripBiddingDetails || {}).business_volume || {}).unit) ? this.getBussinessVolume(((bid.tripBiddingDetails || {}).business_volume || {})) : false)  : undefined,
					average_lpp: rfq.is_average_lpp_approval ? ((bid.price > bid.AverageLPP) ? true : false) : undefined,
					percentage: rfq.is_percentage_base_approval ? this.approverBasedonPercentage(bid) : undefined
					// seeker_remarks: this.state.remarks,
					// seeker_instruction: this.state.instructions,
				};
				if (this.state.remarks !== '') {
					data["seeker_remarks"] = this.state.remarks;
					data["loi_remarks"] = this.state.remarks;
				}
				if (this.state.instructions !== '') {
					data["seeker_instruction"] = this.state.instructions;
				}
				if (isVishaka() && this.state.instructions !== '') {
					data["sendLoiForApproverRemarks"] = this.state.instructions;
				}
				if (this.state.acceptLoiFrom) {
					data["loi_accept_valid_from"] = this.state.acceptLoiFrom
				}
				if (this.state.acceptLoiTo) {
					let acceptLoiToTime = new Date(this.state.acceptLoiTo);
					data["loi_accept_valid_to"] = acceptLoiToTime.getTime()
				}
				if (this.state.loiWithCPPrice === true) {
					data["loi_with_cp_price"] = this.state.loiWithCPPrice;
					if (this.state.cpPrice === '' || this.state.cpPrice === 0.0) {
						alert("Enter Challenge Price");
						return;
					}
					else {
						this.setState({
							isLoiPopupShown: false
						});
					}
					data["challenge_price"] = this.state.cpPrice;

				}
				else {
					this.setState({
						isLoiPopupShown: false
					});
				}
				this.setState({
					cpPrice: 0,
					loiWithCPPrice: false
				})

				return data;
			})
		}
		if(isRoquette) {
			data.approver_price = (this.state.selectedBids || []).reduce((sum, el) => (sum += el['share_of_business_percentage'] ? (el.product_volume_price * (el['share_of_business_percentage'] / 100)) : 0), 0);
			if(rfq.approver_price.length > 0) {
				const maxPrice = Math.max.apply(Math, rfq.approver_price);
				data.approver_price = data.approver_price < maxPrice ? rfq.approver_price.find(val => maxPrice !== val) : maxPrice
			}
		}
		if((data.loi_list || []).length > 0) {
			dispatch({
				type: SEND_LOI,

				data,
				onSuccess: () => {
					this.getSeekerBids.bind(this)
					this.setState({ selectedBids: [], isLoiPopupShown: false })
				}
			});
			this.setState({ remarks: '', instructions: '' });
		} 
		
	}
	sendChallengePrice = (price, trip, priceUSD, priceSecondary, additionalDetails = {}) => {
		const { dispatch, match } = this.props;
		const selectedBids = this.state.selectedBids.length === 0 ? trip.bids : this.state.selectedBids;
		const data = {
			rfq_id: match.params.id,
			rfqType: match.params.type && Number(match.params.type),
			ip_address: localStorage.getItem('IPAddress'),
			price_list: selectedBids.filter((bid) => {
				return !bid.isLoiSent && !bid.isWithDrawBid;
			}).map((bid) => {
				return {
					trip_id: bid.tripId,
					challenge_price: Number(price),
					challenge_price_inr: Number(price),
					challenge_price_usd: priceUSD && Number(priceUSD) || null,
					challenge_price_secondary: priceSecondary && Number(priceSecondary) || null,
					transporter_id: bid.transporterId,
					liner_id: bid.liner_id || undefined,
					cp_accept_valid_from: additionalDetails.fromDate || undefined,
					cp_accept_valid_to: additionalDetails.toDate || undefined
				}
			})
		}
		dispatch({
			type: CHALLENGE_PRICE,
			data,
			onSuccess: () => {
				this.setState({
					selectedBids: []
				})
				this.getSeekerBids(this.state.filters);
			}
		});
		this.setState({
			isChallengePriceShown: false
		})
	}

	sendOtherCostChallengePrice = (value, type, trip) => {
		const { dispatch, match } = this.props;
		const selectedBids = this.state.selectedBids.length === 0 ? trip.bids : this.state.selectedBids;
		const data = {
			rfq_id: match.params.id,
			[type]: selectedBids.filter((bid) => {
				return !bid.isLoiSent;
			}).map((bid) => {
				if(type === 'extra_cost_list') {
					return {
						trip_id: bid.tripId,
						extra_cost_per_km_cp: Number(value),
						transporter_id: bid.transporterId,
					}
				} else {
					return {
						trip_id: bid.tripId,
						other_cost_challenge_price: Number(value[0].cpvalue),
						transporter_id: bid.transporterId,
						cost_charge_id: value[0].cost_charge_id,
						other_cost_challenge_price_inr: Number(value[0].cpvalue_inr),
						other_cost_challenge_price_usd: Number(value[0].cpvalue_usd),
						other_cost_challenge_price_secondary: Number(value[0].cpvalue_secondary),
						liner_id: bid.liner_id || undefined
					}
				}
			})
		}
		dispatch({
			type: OTHER_COST_CHALLENGE_PRICE,
			data,
			onSuccess: () => {
				this.setState({
					selectedBids: []
				})
				this.getSeekerBids();
			}
		});
		this.setState({
			isChallengePriceShown: false
		})
	}
	setBids = (selectedBids) => {
		this.setState({
			selectedBids
		}, () => {
			if (ROQUETTE.includes(getUser().companyId) || DEEPAK_PHENOLICS.includes(getUser().companyId)) {
				const { trips } = this.props;
				const { selectedTrip } = this.state;
				trips.map(trip => {
					const flag = trip.bids.length > 0 && ((selectedBids || []).filter((selectedBid) => {
						return selectedBid.tripId === trip.id;
					 }).length) === (trip.bids || []).length;
					const findTripIndex = (selectedTrip || []).findIndex(sTrip => sTrip.id === trip.id);
					if(flag && findTripIndex === -1) {
						selectedTrip.push(trip)
					} else if(!flag && findTripIndex > -1) {
						selectedTrip.splice(findTripIndex, 1);
					}
				});
				this.setState({
					selectedTrip
				});
			}
		});
	}
	getSeekerBids = (filters = {}) => {
		let approverType = 0, limits = 0;
		if (this.loiApproverType === 10 || this.loiApproverType === 12 || this.loiApproverType == 13) {
			approverType = this.loiApproverType;
			limits = 1000;
		} else {
			limits = RFQ_DISPLAY_LIMIT; //this.props.tripsCount ? this.props.tripsCount : 1000;
		}
		const { dispatch, match } = this.props;
		const dashboardActivestatus = this.props.location.state && this.props.location.state.dashboardActiveView ? this.props.location.state.dashboardActiveView : getDashboardActiveView();
		this.setState({
			filters
		})
		dispatch({
			type: FETCH_SEEKER_BIDS,
			params: {
				rfqId: match.params.id,
				rfqType: match.params.type,
				limit: limits,
				type: (approverType !== 0) ? approverType : (dashboardActivestatus || undefined),
				...filters
			},
			onSuccess: ((data) => {
				this.setSeekerBidsTimer();
				this.setState({
					isTimerShown: false,
					approverMsg: data.approver_message,
					shareOfBusinessLoader: false
				}, () => {
					this.setState({
						isTimerShown: true 
					})
				});
			}),
			onError: this.seekerBidsTimer
		})
	}
	setSeekerBidsTimer = () => {
		if (this.unmounted) { return };
		if (this.seekerBidsTimer) {
			clearTimeout(this.seekerBidsTimer);
		}
		this.seekerBidsTimer = setTimeout(() => {
			this.getSeekerBids(this.state.filters);
		}, 10000);

	}
	updateBiddingEnd = () => {
		let biddingEndTime;
		const { dispatch, rfq } = this.props;
		const { biddingEnd } = this.state;

		this.hideChangeBidding();
		if (biddingEnd === rfq.rfqDetails.biddingEnd || !biddingEnd) {
			return;
		}
		dispatch({
			type: CHANGE_BID_END,
			data: {
				rfq_id: rfq.id,
				rfqType: rfq.type,
				bidding_end: biddingEnd
			},
			onSuccess: this.getSeekerBids.bind(this)
		});

	}

	sendLOIForApprover = (val) => {
		const { rfq } = this.props;
		let { selectedBids, sobList } = this.state;
		const dashboardActivestatus = this.props.location.state && this.props.location.state.dashboardActiveView ? this.props.location.state.dashboardActiveView : getDashboardActiveView();
		const isEmamiCompleteSolution = ([...EMAMI].includes(getUser().companyId) && rfq && !rfq.rfqDetails.acceptPartialSolution);
		const beam = BEAM.includes(getUser().companyId);
		// const isCargil = CARGIL.includes(getUser().companyId);
		if(isEmamiCompleteSolution && this.state.showConfirmationPopup) {
			this.setState({
				showConfirmationPopup: false,
				isSendForApprover: false
			});
			return;
		}
		// if((isAdaniWilmar() && !getUser().is_rlm_user && (selectedBids || []).filter(el => el.orderText !== 'L1' && !el.isAccept).length > 0) || (isEmamiCompleteSolution && (selectedBids || []).filter(el => selectedBids[0].transporterId !== el.transporterId && !el.isAccept).length > 0)) {
		if((isEmamiCompleteSolution && (selectedBids || []).filter(el => selectedBids[0].transporterId !== el.transporterId && !el.isAccept).length > 0) || (beam && val !== 'save')) {
			if(!(isEmamiCompleteSolution || beam)) {
				selectedBids = selectedBids.filter(el => el.orderText === 'L1');
			}
			this.setState({
				showConfirmationPopup: true,
				selectedBids,
				isSendForApprover: true
			});
			return;
		} else {
			this.setState({
				showConfirmationPopup: false,
				isSendForApprover: false
			});
		}
		// if(isCargil && (selectedBids || []).filter(el => !el.additional_cost).length > 0) {
		// 	this.setState({
		// 		showConfirmationPopup: true,
		// 		selectedBids
		// 	});
		// 	return;
		// }
		if((selectedBids || []).length === 0) {
			this.setState({
				showConfirmationPopup: false,
				isSendForApprover: false
			});
			return;
		}
		if(rfq.shareOfBusiness && ![10,13,12].includes(dashboardActivestatus)) {
			let lessAllocatedBids = [];
			(selectedBids || []).forEach(el => {
				const sobBid = (sobList || []).find(bid => bid.tripId === el.tripId);
				const isLessSOB = (sobBid ? sobBid.sumOfSOB < 100 : el.sumOfSOB < 100);
				if(isLessSOB) {
					lessAllocatedBids.push(el);
				}
			});
			if(lessAllocatedBids.length > 1) {
				this.setState({
					sobAllocationPopUp: true,
					isLoiApprover: true
				})
			} else {
				this.postLOIForApprover();
			}
		} else {
			this.postLOIForApprover();
		}
	}

	getBussinessVolume = (bv = {}) => {
		let flag = false;
		if(bv.unit === 1) {
			flag =  (bv.value > 250 ? true : false)
		} else if(bv.unit === 9) {
			flag =  (bv.value > 10 ? true : false)
		}
		return flag;
	}

	postLOIForApprover = () => {
		const user = getUser();
		const dashboardActivestatus = this.props.location.state && this.props.location.state.dashboardActiveView ? this.props.location.state.dashboardActiveView : getDashboardActiveView();
		if(HIKAL.includes(user.companyId) && dashboardActivestatus === 5 && !this.state.sendLoiForApproverRemarks) {
			this.setState({
				showLOIApproverRemarks: true,
				sendLoiForApproverRemarks: ''
			});
			return;
		}
		if(this.state.showLOIApproverRemarks) {
			this.setState({
				showLOIApproverRemarks: false
			})
		}
		const { dispatch, rfq, systemTime } = this.props;
		const { selectedBids, sendLoiForApproverRemarks, loi_remarks, loi_docs } = this.state;
		const isRoquette = ROQUETTE.includes(getUser().companyId);
		const tegUser = JSON.parse((getCookie('teg-user')));
      	const userName = tegUser.adminName;
		const remarksValue = (isCoromandel() || isVishaka())? this.state.instructions : sendLoiForApproverRemarks;
		const data =  {
			rfq_id: rfq.id,
			is_loi_approver: true,
			is_average_lpp_approval: rfq.is_average_lpp_approval,
			is_percentage_base_approval: rfq.is_percentage_base_approval,
			loi_approve_type: 8,
			loi_remarks,
			loi_docs,
			...(isBeamS() ? { userName } : ''), 
			loi_list: selectedBids.filter((bid) => {
				return (isRoquette ? (dashboardActivestatus === 5 ? ((bid.isLoiApproved) ? (((bid.isLoiSent && bid.isAccept === false)) ? true : (bid.loiAcceptValidTo <= systemTime)) : (!bid.isSentLoiApprover && !bid.isLoiApproved)) : true) : (!bid.isAccept)) && ((rfq.shareOfBusiness && ![10,13,12].includes(dashboardActivestatus)) ? ((isRoquette ? bid.share_of_business_percentage : (bid.share_of_business_percentage || bid.share_of_business_percentage == 0)) && bid.sumOfSOB == 100) : true);
			}).map((bid) => {
				const data = {
					trip_id: bid.tripId,
					transporter_id: bid.transporterId,
					sendLoiForApproverRemarks: remarksValue,
					business_volume: rfq.is_average_lpp_approval ? ([1, 9].includes(((bid.tripBiddingDetails || {}).business_volume || {}).unit) ? this.getBussinessVolume(((bid.tripBiddingDetails || {}).business_volume || {})) : false)  : undefined,
					average_lpp: rfq.is_average_lpp_approval ? ((bid.price > bid.AverageLPP) ? true : false) : undefined,
					percentage: rfq.is_percentage_base_approval ? this.approverBasedonPercentage(bid) : undefined
				};
				return data;
			})
		}
		if(isRoquette) {
			data.is_price_base_approval = true;
			data.approver_price = (selectedBids || []).reduce((sum, el) => (sum += el['share_of_business_percentage'] ? (el.product_volume_price * (el['share_of_business_percentage'] / 100)) : 0), 0);
			if(rfq.approver_price.length > 0) {
				const maxPrice = Math.max.apply(Math, rfq.approver_price);
				data.approver_price = data.approver_price < maxPrice ? rfq.approver_price.find(val => maxPrice !== val) : maxPrice
			}
		}
        
		if(isDesmet()){
			data.is_price_base_approval = true
			const totalAmount = (selectedBids || []).reduce((acc,cEle)=>{
				return acc + cEle.price
			},0)
			const C1 = totalAmount >= 1 && totalAmount <= 200000
			const C2 = totalAmount > 200000 
			if(C1){
				data.approver_price = 200000
			}
			if(C2){
				data.approver_price = 200001
			}
		}
       
		
		if((data.loi_list || []).length > 0) {
			dispatch({
				type: ADD_LOI_APPROVER,
				data,
				onSuccess: (data) => {
					this.setState({
						selectedBids: [],
						sobAllocationPopUp: false,
						loiApprover: false,
						sendLoiForApproverRemarks: '',
						loi_remarks: '',
						loi_docs: [],
						isSendApproverPopupShown: false,
					});
					this.getSeekerBids();
					// this.getSeekerBids.bind(this)
				}
			});
		} else {
			this.setState({
				sobAllocationPopUp: false,
				loiApprover: false
			});
		}
	}

	approverRejectedLOI = () => {
		const { dispatch, rfq } = this.props;
		const { selectedBids, approverLoiRemarks } = this.state;
		dispatch({
			type: POST_REJECT_LOI_FROM_APPROVER,
			data: {
				rfq_id: rfq.id,
				rfqType: rfq.type,
				ip_address: localStorage.getItem('IPAddress'),
				approver_loi_reject_remarks: approverLoiRemarks,
				reject_approver_loi_list: selectedBids.map((bid) => {
					const data = {
						trip_id: bid.tripId,
						transporter_id: bid.transporterId
					};
					return data;
				})
			},
			onSuccess: () => {
				this.setState({ isLoiApproverPopupShown: false, loiApproverPopupType: '', approverLoiRemarks: '', selectedBids: [] });
				this.getSeekerBids();
			}
		})
	}

	sendApproverMessageForUser = () => {
		const { dispatch, rfq } = this.props;
		const userData = getUser();
		if(this.state.loiApproverPopupType === 2) {
			this.approverRejectedLOI();
		} else {
			if (this.state.approverLoiRemarks) {
				dispatch({
					type: SEND_APPROVER_LOI_MESSAGE,
					data: {
						rfq_id: rfq.id,
						approver_message: this.state.approverLoiRemarks,
						approver_email: userData.email,
						approver_branch_name: userData.branchName
					},
				});
				this.setState({ isLoiApproverPopupShown: false, loiApproverPopupType: '' });
			} else {
				this.setState({ errorMessage: "Please enter message" });
			}
		}
	}

	onApproverMessageChange = (e) => {
		this.setState({
			approverLoiRemarks: e.target.value
		});
		this.setState({ errorMessage: "" });
	}

	handleRFQCancellation = (rfqId, rfqType) => {
		const { dispatch, history, match } = this.props;
		this.setState({ showCancelPopup: false })
		dispatch({
			type: CANCEL_RFQ,
			data: {
				rfq_id: rfqId,
				rfqType,
				cancel_rfq_remarks: this.state.cancelRFQRemarks
			},
			onSuccess: (() => {
				history.push('/seeker');
			})
		});
	}
	showChangeBidding = (type, isTriplevel) => {
		if (type === 'isChangeSpecificBidShown') {
			this.setState({
				isChangeSpecificBidShown: true,
				isChangeBidShown: false,
			});
		} else {
			this.setState({
				isChangeBidShown: true,
				isChangeSpecificBidShown: false,
				isTriplevel: isTriplevel
			});
		}
	}
	hideChangeBidding = (type) => {
		if (type === 'isChangeSpecificBidShown') {
			this.setState({
				isChangeSpecificBidShown: false,
			});
		} else {
			this.setState({
				isChangeBidShown: false,
				isTriplevel: false
			});
		}
	}
	componentWillUnmount() {
		this.unmounted = true;
		if (this.seekerBidsTimer) {
			clearTimeout(this.seekerBidsTimer);
		}
		const { dispatch } = this.props;
		dispatch({
			type: CLEAR_RFQ_DETAIL
		});
	}

	refreshSeekerBids = (filters) => {
		const { dispatch } = this.props;
		dispatch({
			type: CLEAR_FETCH_SEEKER_BIDS
		})
		this.getSeekerBids(filters);
	}
	uploadBiddingDetails = (file) => {
		const { dispatch, match, rfq } = this.props;
		dispatch({
			type: UPLOAD_BIDDING_DETAILS,
			file,
			params: {
				type: 3,
				rfqType: rfq.type,
				rfqId: match.params.id,
				serviceType: rfq.rfqDetails.serviceType,
				ip_address: localStorage.getItem('IPAddress')
			},
			onSuccess: this.getSeekerBids
		});
	}
	downloadBiddingDetails = () => {
		const { dispatch, match } = this.props;
		let rfqType = this.props.rfq.type
		let serviceType =this.props.rfq.serviceType;
		dispatch({
			type: DOWNLOAD_BIDDING_DETAILS,
			params: {
				type: (serviceType === 3) ? 2 : (rfqType === 1) ? 3 : (rfqType === 2 || rfqType === 5) ? 4 : 5,
				rfqType,
				rfqId: match.params.id,
				serviceType:serviceType
			},
			onSuccess: (data) => {
				this.setState({
					downloadBiddingDetailsUrl: data.url
				}, () => {
					this.downloadBiddingDetailsButton.click();
				})
			}
		});
	}

	onChangeBusinessVolume = (key, value) => {
		this.setState(prev => ({
			businessVolume: {
				...prev.businessVolume,
				[key]: value
			}
		}));
	};

	onSaveBusinessVolume = () => {
		const { businessVolume, selectedBids, activeBidIndex = 0 } = this.state;
		const user = getUser();
		const { rfq, dispatch } = this.props;

		const selectedBid = selectedBids[activeBidIndex];

		if (!selectedBid) return;

		const payload = {
			company_id: user.companyId,
			user_id: user.id,
			user_name: user.name,
			rfq_type: rfq.type,
			rfq_id: rfq.id,

			trip_id: selectedBid.tripId,

			business_volume: {
				value: Number(businessVolume.value),
				name: businessVolume.name,
				unit: businessVolume.unit
			}
		};

		dispatch({
			type: POST_UPDATE_BUSINESS_VOLUME,
			data: payload,
			onSuccess: () => {
				this.setState({ updateBusinessVolume: false });
				this.getSeekerBids
			}
		});
	};


	onRemarksChange = (e) => {
		this.setState({ remarks: e.target.value });
	}
	onInstructionsChange = (e) => {
		this.setState({ instructions: e.target.value });
	}
	onCPChange = (e) => {
		this.setState({ cpPrice: Number(e.target.value) });
	}
	loiWithCPPriceChange = (e) => {
		this.setState({ loiWithCPPrice: e.target.checked });
	}
	componentDidMount() {
		const { dispatch, rfq, selectedNavBranch } = this.props;
		const user = getUser();
		const newData = {
			rfqType: rfq?.type,
			companyId: user?.id,
			branchId: (selectedNavBranch || {})?.branch_id || user?.branchId
		}
		dispatch({
			type: CLEAR_FETCH_SEEKER_BIDS
		})
		dispatch({
			type: GET_ZONES
		})
		dispatch({
			type: GET_CURRENCY_DETAILS
		})
		dispatch({ type: GET_MOVEMENTS });
		dispatch({ type: GET_MODES });
		dispatch({ type: GET_IP_ADDRESS });
		dispatch({ type: GET_CURRENCY_TYPES });
		this.getSeekerBids();
		if(isVishaka()){
		dispatch({ type: GET_BUSINESS_VOLUMES, data: newData });
		}
		

	}

	getSeekerTransporters = (filters = {}) => {
		const { dispatch, match } = this.props;
		dispatch({
			type: GET_SEEKER_TRANSPORTERS,
			params: {
				rfqId: match.params.id,
				...filters,
				limit:400,
			}   
		});
	}

	onFromDateChange = (date) => {
		this.setState({ acceptLoiFrom: date });
	}
	onToDateChange = (date) => {
		this.setState({ acceptLoiTo: date });
	}
	onFocusedFrom = (focusedFrom) => {
		this.setState({ focusedFrom, focusedTo: false });
	}
	onFocusedTo = (focusedTo) => {
		this.setState({ focusedTo, focusedFrom: false });
	}
	postBid = (tripId, bidEnd) => {
		const { dispatch, match } = this.props;
		const { selectedBids } = this.state;
		this.hideChangeBidding('isChangeSpecificBidShown');

		const hasCP = selectedBids.filter((bid) => { return bid.challengePrice })
		if (hasCP.length > 0) {
			dispatch({
				type: TOAST_ERROR,
				message: "Cannot Increase Bid Time After Giving Challenge Price"
			});
			return;
		}

		dispatch({
			type: CHANGE_TRIP_BID_END,
			data: {
				rfq_id: match.params.id,
				rfqType: match.params.type && Number(match.params.type),
				ip_address: localStorage.getItem('IPAddress'),
				trip_bid_end: new Date(this.state.biddingEnd).getTime(),
				trips: selectedBids.filter((bid) => {
					return !bid.isAccept;
				}).map((bid) => {
					const data = {
						trip_id: bid.tripId,
						transporter_id: bid.transporterId,
					};
					return data;
				})
			},
			// onSuccess: this.getTrips.bind(this)
		});
	}
	postChallengePrice = (tripId, bidData) => {
		const { dispatch, match } = this.props;
		
		dispatch({
			type: COUNTER_PRICE_FOR_SEEKER,
			params: {
				rfq_id: match.params.id,
				rfqType: match.params.type && Number(match.params.type),
				ip_address: localStorage.getItem('IPAddress'),
				trip_id: tripId,
				...bidData
			},
			onSuccess: this.getSeekerBids.bind(this)
		});
	}

	deleteTripDetails = (tripId, rfqId, parentTripId) => {
		const { dispatch, match } = this.props;
		dispatch({
			type: DELETE_TRIP_DETAILS,
			data: {
				tripId: tripId,
				rfqId: rfqId,
				rfqType: match.params.type && Number(match.params.type),
				parentTripId: parentTripId
			},
			onSuccess: this.getSeekerBids.bind(this)
		});
	}
	selectedTripsHasMinBidders = () => {
		const { trips, rfq } = this.props;
		const { selectedBids } = this.state;
		let hasMinBidders = true;
		if (trips && selectedBids.length > 0) {
			for (let i = 0; (i < trips.length); i++) {
				for (let j = 0; (j < selectedBids.length); j++) {
					if (selectedBids[j].tripId === trips[i].id && rfq.minBidders > (trips[i].bids || []).length) {
						hasMinBidders = false;
						return hasMinBidders;
					} else {
						hasMinBidders = true;
					}
				}
			}
		}
		return hasMinBidders;
	}

	downloadBiddingSeekerTrailDetails = () => {
		const { dispatch, match } = this.props;
		dispatch({
			type: DOWNLOAD_BIDDING_TRAIL,
			params: {
				type: 1,
				rfqType: match.params.type,
				rfqId: match.params.id
			},
			onSuccess: (data) => {
				this.setState({
					downloadBiddingDetailsUrl: data.url
				}, () => {
					this.downloadBiddingDetailsButton.click();
				})
			}
		});
	}
	fetchBids(tripId, transporterId, linerId) {
		const { dispatch, match } = this.props;
		dispatch({
		   type: FETCH_BIDS,
		   params: {
			  tripId: tripId,
			  rfqType: match.params.type,
			  transporterId: transporterId,
			  linerId: linerId || undefined
		   }
		});
	 }

	fetchTranspBidCommonCharges  = (data) => {
		const { dispatch, match } = this.props;
		dispatch({
			type: GET_TRANSPORTER_BID_COMMON_CHARGES,
			params: {
				rfqId: match.params.id,
				...data
			}
		})
	}


	downloadBiddingRate = () => {
		const { dispatch, match } = this.props;
		let rfqType = this.props.rfq.type
		
		dispatch({
			type: DOWNLOAD_BIDDING_RATE,
			params: {
				type: 1,
				rfqId: match.params.id,
			},
			onSuccess: (data) => {
				this.setState({
					downloadBiddingDetailsUrl: data.url
				}, () => {
					this.downloadBiddingDetailsButton.click();
				})
			}
		});
	}
	uploadBiddingRatePopUp = (file) => {
		this.setState({
			showCancelPopup: true
		})
		this.setState({
			updatedRateFile : file
		});
	}

	uploadUpdateRate =()=>{
		const { dispatch, match } = this.props;
		const { updatedRateFile } = this.state;
        this.setState({
			showCancelPopup: false
		});
		dispatch({
			type: UPLOAD_BIDDING_RATE,
			file : updatedRateFile,
			params: {
				type: 1,
				rfqId: match.params.id,
				ip_address: localStorage.getItem('IPAddress')
			},
			onSuccess: this.getSeekerBids
		});
	}

	downloadTrucksDetails = () => {
		const { dispatch, match } = this.props;
		dispatch({
			type: DOWNLOAD_TRUCKS,
			params: {
				type: 1,
				rfqId: match.params.id,
			},
			onSuccess: (data) => {
				this.setState({
					downloadBiddingDetailsUrl: data.url
				}, () => {
					this.downloadBiddingDetailsButton.click();
				})
			}
		});
	}

	uploadNumberOfTrucksPopUp = (file) => {
		this.setState({
			isTruckUpload: true,
			updatedNumberOfTruckFile : file
		})
	}

	uploadNumberOfTrucks =()=>{
		const { dispatch, match } = this.props;
		const { updatedNumberOfTruckFile } = this.state;
		this.setState({
			isTruckUpload: false
		});
		dispatch({
			type: UPLOAD_NUMBER_OF_TRUCKS,
			file :updatedNumberOfTruckFile,
			params: {
				type: 1,
				ip_address: localStorage.getItem('IPAddress')
			},
			onSuccess: this.getSeekerBids
		});
		
	}

	saveNumberOfVehiclePlaced = (data) => {
		const { dispatch, match } = this.props;
		dispatch({
			type: NUMBER_OF_VEHICLE_PLACED,
			data: {
				trip_id : data.trip_id,
				rfq_id :data.rfq_id,
				placed_number_of_trucks : data.placed_number_of_trucks
			},
			onSuccess: this.getSeekerBids
		});
	}

	closedRfqPopUp = () => {
		this.setState({
			isClosedRfqPopUp: true,
		})
	}

	revokeWithdrawBid = (tripId, rfqId, transporterId, tripbidend) => {
		const { dispatch, rfq } = this.props;	
		let isValid = tripbidend > 0 && (this.props.rfq && this.props.rfq.rfqDetails && this.props.rfq.rfqDetails.biddingEnd > new Date().getTime()) || true;

		if(isValid && tripbidend>0){
			isValid=(tripbidend> new Date().getTime());
		}
		if(!isValid){
			alert("Please Change Bid End Time")
			return ;
		}
		dispatch({
			type: REVOKE_WITHDRAW_BID,
			data: {
				rfq_id: rfqId,
				trip_id: tripId,
				transporter_id: transporterId,
				rfqType: rfq.type && Number(rfq.type),
				ip_address: localStorage.getItem('IPAddress'),
			},
			onSuccess: this.getSeekerBids.bind(this)
		});
	}

	rfqClosed = () => {
		const { dispatch, rfq } = this.props;
		const user = getUser();
		this.setState({
			isClosedRfqPopUp: false
		});
		dispatch({
			type: CLOSED_RFQ,
			data: {
				rfq_id: rfq.id,
				company_id: user.companyId
			}
		});
	}

	acceptanceCeilingPrice=()=>{
		const { dispatch, rfq } = this.props;
		const user = getUser();
		const data={
			rfq_id: rfq.id,
			company_id: user.companyId,
			trip_list: this.state.selectedBids.filter((bid) => {
				return  bid.tripId;
			}).map((bid) => {
				const data = {
					trip_id: bid.tripId
				};
				
				return data;
			}),
		}
		dispatch({
			type: ACCEPTANCE_CEILING_PRICE,
			data
		});
	}

	getVehicleTypes = () => {
		const { rfq, dispatch } = this.props;
		const params = {
			rfqType: rfq.type,
			companyId: rfq.companyId,
			branchId: rfq.branchId
		}
		dispatch({
			type: GET_VEHICLE_TYPES,
			params
		})
	}

	revokeMultipleWithdrawBid = () => {
		const { selectedBids } = this.state;
		const { dispatch, rfq } = this.props;
		const revokeList = [];
		(selectedBids || []).forEach(bid => {
			if(bid.isWithDrawBid && !bid.isAccessBidWithdrawn) {
				revokeList.push({
					'trip_id': bid.tripId,
					'transporter_id': bid.transporterId
				});
			}
		});
		
		if(revokeList.length > 0) {
			dispatch({
				type: REVOKE_WITHDRAW_BID,
				data: {
					rfq_id: rfq.id,
					rfqType: rfq.type && Number(rfq.type),
					ip_address: localStorage.getItem('IPAddress'),
					revoke_all_bidwithdrawn: true,
					revokeList
				},
				onSuccess: () => {
					this.setState({
						selectedBids: []
					});
					this.getSeekerBids.bind(this);
				}
			});
		}
	}

	postSOB = (trip) => {
		const { dispatch, match } = this.props;
		const rfqType = match.params.type && Number(match.params.type);
		const data = {
			rfq_id: match.params.id,
			rfqType,
			ip_address: localStorage.getItem('IPAddress'),
		};

		if (!isCoromandel() || !isVishaka()) {
			data.sob_list = [{ ...trip }]
		}
		if (isCoromandel() || isVishaka()) {
			data.sob_list = trip
		}

		this.setState({ shareOfBusinessLoader: true });

		dispatch({
			type: POST_SHARE_OF_BUSINESS,
			data,
			onSuccess: () => {
				let { sobList } = this.state;
				if (!sobList) {
					sobList = [{ ...trip }]
				} else {
					sobList.push(trip);
				}

				this.setState({
					sobList,
					shareOfBusinessLoader: false
				});

				// Refresh bids to get updated SOB data
				this.getSeekerBids();
			}
		});
	}

	openUpdateDPHPopup = () => {
		this.setState({
			isDPHPopup: true,
			dph: {}
		})
	}

	closeUpdateDPHPopup = () => {
		this.setState({
			isDPHPopup: false,
			dph: {}
		});
	}

	onChangeDPH = (type, e) => {
		const { dph } = this.state;
		if(type === 'date') {
			const { startDate, endDate } = e;
			dph['dph_from_date'] = startDate && new Date(startDate).setHours(0, 0, 0, 0) || undefined;
			dph['dph_to_date'] = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
			this.setState({ dph });
		} else if(type === 'percentage') {
			dph['dph_percentage'] = e.target.value && Number(e.target.value);
			this.setState({	dph });
		} else if(type === 'remarks') {
			dph['dph_remarks'] = e.target.value;
			this.setState({	dph });
		} else if(type === 'uom') {
			dph['dph_uom'] = e;
			this.setState({	dph });
		} else if(type === 'dph_from_date') {
			dph['dph_from_date'] = e && new Date(e).setHours(0, 0, 0, 0) || undefined;
		}
	}

	updateDPH = () => {
		const { dispatch, rfq } = this.props;
		const { selectedBids, dph } = this.state;
		const user = getUser();
		dispatch({
			type: UPDATE_DPH_DETAILS,
			data: {
				rfq_id: rfq.id,
				rfqType: rfq.type,
				ip_address: localStorage.getItem('IPAddress'),
				dph_from_date: dph.dph_from_date,
				dph_to_date: dph.dph_to_date,
				dph_list: selectedBids.filter((sbid) => {
					return sbid.isAccept && (!sbid.isSentDPHApprover || sbid.isDPHApproved) }).map((bid) => {
					const data = {
						trip_id: bid.tripId,
						transporter_id: bid.transporterId,
						company_id: user.companyId,
						dph_percentage: dph.dph_percentage,
						dph_uom: dph.dph_uom,
						dph_remarks: dph.dph_remarks,
						dph_to_date: ROQUETTE.includes(getUser().companyId) ? (bid.tripContractTenureTo || rfq.rfqDetails.contractTenureTo) : undefined
					};
					return data;
				})
			},
			onSuccess: () => {
				this.setState({ selectedBids: [] });
				this.getSeekerBids();
			}
		})
		this.closeUpdateDPHPopup();
	}

	isEnableSendLoi = () => {
		const { rfq, trips } = this.props;
		const { selectedBids } = this.state;
		const isEmami = ([...EMAMI, ...STAR_CEMENT].includes(getUser().companyId) && rfq && !rfq.rfqDetails.acceptPartialSolution);
		let flag = true;
		if(isEmami) {
			const tripsTransporters = ((trips[0] || []).bids || []);
			(tripsTransporters || []).forEach(bid => {
				const selectedTrans = (selectedBids || []).filter(sBid => sBid.transporterId === bid.transporterId);
				if(selectedTrans.length > 0 && selectedTrans.length !== trips.length) {
					flag = false;
				}
			})
		}
		return flag;
	}

	selectTrip = (trip) => {
		const { selectedTrip } = this.state;
		const tripIndex = (selectedTrip || []).findIndex(el => el.id ===  trip.id);
		if(tripIndex > -1) {
			selectedTrip.splice(tripIndex, 1);
		} else {
			selectedTrip.push(trip);
		}
		this.setState({ selectedTrip });
	}

	extendContractTenure = () => {
		const { rfq } = this.props;
		this.setState({
			CTData: {
				contractTenureFrom: (rfq.rfqDetails || {}).contractTenureFrom,
				contractTenureTo: (rfq.rfqDetails || {}).contractTenureTo
			},
			extendContractTenure: true
		});
	}


	updateBusinesVolume = () => {
		const selectedBid = this.state.selectedBids?.[0];

		const businessVolume =
			selectedBid?.tripBiddingDetails?.business_volume || {};

		this.setState({
			updateBusinessVolume: true,
			businessVolume: {
				value: businessVolume.value || '',
				unit: businessVolume.unit || null,
				name: businessVolume.name || ''
			}
		});
	}

	rfqTollUpdatePrice = () => {
		const { rfq } = this.props;
		this.setState({
			CTData: {
				contractTenureFrom: (rfq.rfqDetails || {}).contractTenureFrom,
				contractTenureTo: (rfq.rfqDetails || {}).contractTenureTo
			},
			rfqTollUpdatePrice: true
		});
	}

	onCloseExtendCT = () => {
		this.setState({ extendContractTenure: false });
	}

	onCloseUpdateBusinessVolume = () => {
		this.setState({ updateBusinessVolume: false });
	}

	onCloseRfqTollUpdatePrice = () => {
		this.setState({ rfqTollUpdatePrice: false });
	}

	onChangeCT = ({ startDate, endDate }) => {
		const { CTData } = this.state;
		const startDateTime = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : new Date().setHours(0, 0, 0, 0);
		const endTime = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
		CTData.contractTenureFrom = new Date(startDateTime).getTime();
		CTData.contractTenureTo = new Date(endTime).getTime();
		this.setState({
			CTData
		})
	}

	onSaveExtendCT = () => {
		const { selectedBids, CTData } = this.state;
		const { rfq, dispatch } = this.props;
		const beam = BEAM.includes(rfq.companyId);
		const tripList = (beam ? (selectedBids || []).filter(el => el.isAccept) : (selectedBids || [])).map(trip => {
			return {
				trip_id: trip.tripId,
				contract_tenure_from: CTData.contractTenureFrom,
				contract_tenure_to: CTData.contractTenureTo,
				transporter_id: trip.transporterId
			}
		});
		dispatch({
			type: TRIP_LEVEL_CONTRACT_EXTENSION,
			data: {
				rfq_id: rfq.id,
				contract_tenure_list: tripList,
				rfqType: rfq.type,
			},
			onSuccess: () => {
				this.setState({ selectedBids: [] });
				this.getSeekerBids();
			}
		});
		this.onCloseExtendCT();
	}


	postTripBidEndTime = () => {
		if(isFosroc()) {
			this.updateSinglebiddedBidTime();
		} else {
			const { dispatch, rfq } = this.props;
			const { selectedTrip, biddingEnd } = this.state;
			const trips = [];
			(selectedTrip || []).forEach(trip => {
				const isLoiSent = (trip.bids || []).filter(el => (el.isLoiSent || el.isAccept)) || [];
				if(isLoiSent.length === 0) {
					trips.push({
						trip_id: trip.id,
						trip_bidding_end: biddingEnd
					})
				}
			});
			dispatch({
				type: TRIP_LEVEL_BID_EXTENSION,
				data:{
					rfq_id: rfq.id,
					rfqType: rfq.type,
					ip_address: localStorage.getItem('IPAddress'),
					trips
				},
				onSuccess: this.getSeekerBids
			})
			this.hideChangeBidding();
		}
	}

	getDPHApprovalText = () => {
		let approvalText = 'Approve DPH';
		const dashboardActivestatus = this.props.location.state && this.props.location.state.dashboardActiveView ? this.props.location.state.dashboardActiveView : getDashboardActiveView();
		const user = getUser();
		const { rfq } = this.props;
		if (rfq && rfq.dphloiApproverEmails.length > 0 && rfq.dphloiApproverEmails.includes(user.email)) {
				approvalText = 'Approve DPH';
		} else if (rfq && rfq.dphapprovalMatrixEmails.length > 0) {
			for (let i = 0; i < rfq.dphapprovalMatrixEmails.length; i++) {
				let isDPHApproverValid = (rfq.dphapprovalMatrixEmails[i] === user.email);
				if(user.isDphApprover && rfq.user_email === user.email && dashboardActivestatus !== 71) {
					const loiPrice = (this.state.selectedBids || []).reduce((sum, el) => (sum += ((el['share_of_business_percentage']) ? (el.dph_product_volume_price * (el['share_of_business_percentage'] / 100)) : 0)), 0);
					if(loiPrice <= rfq.dph_approver_price) {
						isDPHApproverValid = true;
					}
				}
				if (isDPHApproverValid && rfq.dphloiApproverEmails[i] !== user.email) {
					approvalText = "Approve DPH";
					break;
				} else if (!isDPHApproverValid && rfq.dphloiApproverEmails[i] !== user.email) {
					approvalText = `Send DPH for Approver`;
				}
			}
		} else {
			if (rfq && rfq.dphApproverEmail.length > 0) {
				approvalText = `Send DPH for Approver`;
			}
			if(user.isDphApprover && rfq.user_email === user.email && dashboardActivestatus !== 71) {
				const loiPrice = (this.state.selectedBids || []).reduce((sum, el) => (sum += (el['share_of_business_percentage']) ? (el.dph_product_volume_price * (el['share_of_business_percentage'] / 100)) : 0), 0);
				if(loiPrice <= rfq.dph_approver_price) {
					approvalText = "Approve DPH";
				}
			}
		}
		if(rfq.dphApproverEmail.length > 0 && dashboardActivestatus === 71) {
			const loiPrice = (this.state.selectedBids || []).reduce((sum, el) => (sum += (el['share_of_business_percentage']) ? (el.dph_product_volume_price * (el['share_of_business_percentage'] / 100)) : 0), 0);
			const maxPrice = Math.max.apply(Math, rfq.dph_approver_price);
			const aPrice = loiPrice < maxPrice ? rfq.dph_approver_price.find(val => maxPrice !== val) : maxPrice;
			const levels = (rfq.dphApproverEmail || []).filter(approver => aPrice == approver.price);
			if(levels) {
				const emails = ((levels[0] || {}).levels || []).map(level => level.emails);
				const maxEmails =  (((rfq.dphApproverEmail || []).filter(approver => maxPrice == approver.price)[0] || {}).levels || []).map(level => level.emails);
				(emails || []).forEach(email => {
					let isLoiApproverValid = ((email.includes(getUser().email)) || (maxEmails[maxEmails.length - 1].includes(getUser().email)));
					if(isLoiApproverValid) {
						approvalText = `Approve DPH`;
					} else {
						approvalText = `Send DPH For Approver`;
					}
				})
			}
		}
		return approvalText;
	}

	sendDPHForApprover = () => {
		if(this.getDPHApprovalText().includes('Approve DPH')) {
			this.approveDPH()
		}  else {
			const { dispatch, rfq } = this.props;
			const { selectedBids } = this.state;
			const isRoquette = ROQUETTE.includes(getUser().companyId);
			const Beam = BEAM.includes(getUser().companyId);
			const dashboardActivestatus = this.props.location.state && this.props.location.state.dashboardActiveView ? this.props.location.state.dashboardActiveView : getDashboardActiveView();
			const data =  {
				rfq_id: rfq.id,
				rfqType: rfq.type,
				is_loi_approver: true,
				loi_approve_type: 8,
				loi_list: selectedBids.filter((bid) => {
					return bid.revised_price && ((rfq.shareOfBusiness && ![10,13,12,71,72,73].includes(dashboardActivestatus)) ? (bid.share_of_business_percentage && (!bid.isSentDPHApprover && !bid.isDPHApproved)) : true);
				}).map((bid) => {
					const data = {
						trip_id: bid.tripId,
						transporter_id: bid.transporterId
					};
					return data;
				})
			}
			if(isRoquette || Beam) {
				data.is_price_base_approval = true;
				data.dph_approver_price = 500000;
				// data.approver_price = (selectedBids || []).reduce((sum, el) => (sum += ((el['share_of_business_percentage'] && (dashboardActivestatus === 9 ? (!el.isSentDPHApprover && !el.isDPHApproved) : true)) ? (el.dph_product_volume_price * (el['share_of_business_percentage'] / 100)) : 0)), 0);
				// if(rfq.dph_approver_price.length > 0) {
				// 	const maxPrice = Math.max.apply(Math, rfq.dph_approver_price);
				// 	data.dph_approver_price = data.approver_price < maxPrice ? rfq.dph_approver_price.find(val => maxPrice !== val) : maxPrice
				// }
			}
			if((data.loi_list || []).length > 0) {
				dispatch({
					type: POST_DPH_APPROVAL,
					data,
					onSuccess: (data) => {
						this.setState({
							selectedBids: [],
							sobAllocationPopUp: false,
							loiApprover: false
						})
						this.getSeekerBids.bind(this)
					}
				});
			} else {
				this.setState({
					sobAllocationPopUp: false,
					loiApprover: false
				});
			}
		}
	}

	approveDPH = () => {
		const { dispatch, rfq } = this.props;
		const { selectedBids } = this.state;
		const isRoquette = ROQUETTE.includes(getUser().companyId);
		const Beam = BEAM.includes(getUser().companyId);
		const dashboardActivestatus = this.props.location.state && this.props.location.state.dashboardActiveView ? this.props.location.state.dashboardActiveView : getDashboardActiveView();
		const data =  {
			rfq_id: rfq.id,
			rfqType: rfq.type,
			loi_with_cp_price: false,
			is_approver_type: 10,
			loi_list: selectedBids.filter((bid) => {
				return ((isRoquette && dashboardActivestatus === 9) ? (!bid.isSentDPHApprover && !bid.isDPHApproved) : true) && ((rfq.shareOfBusiness && ![10,13,12,71,72, 73].includes(dashboardActivestatus)) ? bid.share_of_business_percentage : true);
			}).map((bid) => {
				const data = {
					trip_id: bid.tripId,
					transporter_id: bid.transporterId
				};
				return data;
			})
		}
		if((isRoquette || Beam)) {
			data.is_price_base_approval = true;
			data.dph_approver_price = 500000;
			// data.approver_price = (selectedBids || []).reduce((sum, el) => (sum += ((el['share_of_business_percentage'] && (dashboardActivestatus === 9 ? (!el.isSentDPHApprover && !el.isDPHApproved) : true)) ? (el.dph_product_volume_price * (el['share_of_business_percentage'] / 100)) : 0)), 0);
			// if(rfq.dph_approver_price.length > 0) {
			// 	const maxPrice = Math.max.apply(Math, rfq.dph_approver_price);
			// 	data.dph_approver_price = data.approver_price < maxPrice ? rfq.dph_approver_price.find(val => maxPrice !== val) : maxPrice
			// }
		}
		dispatch({
			type: POST_APPROVE_DPH,
			data,
			onSuccess: (data) => {
				this.setState({
					selectedBids: []
				})
				this.getSeekerBids.bind(this)
			}
		})
	}

	onRetriggerTK11 = () => {
		const { rfq, dispatch } = this.props;
		dispatch({
			type: RETRIGGER_TK11_FOR_RFQ,
			data: {
				company_id: getUser().companyId,
				rfq_id: rfq.id
			}
		})
	}

	uploadSOBDetails = (file) => {
		const { dispatch, match, rfq } = this.props;
		dispatch({
			type: UPLOAD_SOB_DETAILS,
			file : file,
			params: {
				type: 1,
				rfqId: match.params.id,
				rfqType: rfq.type
			},
			onSuccess: this.getSeekerBids
		})
	}

	downloadSOBTemplate = () => {
		const { dispatch, rfq } = this.props;
		dispatch({
			type: DOWNLOAD_SOB_TEMPLATE,
			params: {
				type: 1,
				rfqType: rfq.type,
				rfqId: rfq.id
			},
			onSuccess: (url) => {
				if(url) {
					downloadUrl(url);
				}
			}
		})
	}

	onCancelLOIApproverRemarksPopup = () => {
		this.setState({
			showLOIApproverRemarks: false,
			sendLoiForApproverRemarks: ''
		})
	}

	uploadSlabWiseOfflineTrips = (file) => {
		const { dispatch, match, rfq } = this.props;
		dispatch({
			type: UPLOAD_OFFLINE_SLABEWISE_TRIPS,
			file : file,
			params: {
				type: 1,
				rfqId: match.params.id,
				rfqType: rfq.type
			},
			onSuccess: this.getSeekerBids
		})
	}

	downloadSlabWiseOfflineTrips = () => {
		const { dispatch, rfq } = this.props;
		dispatch({
			type: DOWNLOAD_OFFLINE_SLABEWISE_TRIPS,
			params: {
				type: 1,
				rfqType: rfq.type,
				rfqId: rfq.id
			},
			onSuccess: (url) => {
				if(url) {
					downloadUrl(url);
				}
			}
		})
	}

	onClickAddTransporters = () => {
		const { dispatch, rfq, match } = this.props;
		dispatch({
			type: GET_GROUPS_AND_TRANSPORTERS,
			data: {
				branchId: rfq.branchId,
				type: 2,
				rfqType: match.params.type,
			},
			onSuccess: () => {
				this.setState({
					addTransporters: true,
					setTransporters: rfq
				})
			}
		})
	}

	onSaveTransporters = () => {
		const { rfq, dispatch } = this.props;
		const { setTransporters }  = this.state;
		const rfqData = setTransporters.getApiData();
		const newTransporters = JSON.parse(JSON.stringify(rfqData.docs_and_transporters));
		(((newTransporters || {}).transporters || {}).groups || []).forEach((trans, index) => {
			(((newTransporters || {}).transporters || {}).groups || [])[index]['transporters'] = (trans['transporters'] || []).filter(transporter => (!rfq.transporterIds.includes(transporter.id)));
		});
		(((newTransporters || {}).transporters || {}).groups || []).forEach((trans, index) => {
			if((trans.transporters || []).length === 0) {
				((newTransporters || {}).transporters || {}).groups.splice(index, 1);
			}
		});
		(((newTransporters || {}).transporters || {}).transporter_ids) = ((((newTransporters || {}).transporters || {}).transporter_ids || []).filter(el => !(rfq.transporterIds || []).includes(el)));
		if((((newTransporters || {}).transporters || {}).transporter_ids || []).length > 0) {
			dispatch({
				type: ADD_ADDITIONAL_TRANSPORTER_DURING_BIDDING,
				data: {
					'rfq_id': rfqData.rfq_id,
					"rfq_type": rfqData.rfq_type,
					"group": ((newTransporters || {}).transporters || {})
				},
				onSuccess: () => {
					this.getSeekerBids(this.getSeekerBids(this.state.filters));
				}
			})
			this.setState({
				addTransporters: false,
				setTransporters: '',
				shareOfBusinessLoader: true
			})
		}
	}

	onCancelTransporterModel = () => {
		this.setState({
			addTransporters: false
		})
	}

	getRevisedVolumePrice = (bid) => {
		const { rfq } = this.props;
		let contractDays = (Moment(rfq.rfqDetails.contractTenureTo).diff(Moment(rfq.rfqDetails.contractTenureFrom), 'days')) + 1;
		if(bid.tripContractTenureFrom && bid.tripContractTenureTo) {
			contractDays = Moment(bid.tripContractTenureTo).diff(Moment(bid.tripContractTenureFrom), 'days');
		}
		const dphToContractDaysDiff = (Moment(bid.dph_from_date).diff(Moment(bid.tripContractTenureFrom ? bid.tripContractTenureFrom : rfq.rfqDetails.contractTenureFrom), 'days')) + 1;
		const remainingDays = (contractDays - dphToContractDaysDiff);
		const newPrice = ((bid.revised_price - bid.current_price) * ((((bid.tripBiddingDetails || {}).business_volume || {}).value) * (remainingDays / contractDays))) || 0;
		return newPrice;
	}

	showPRDetails = (transporterId, tripId) => {
		const { dispatch, rfq } = this.props;
		dispatch({
			type: transporterId ? GET_TRANSPORTER_LEVEL_PR_DETAILS : GET_RFQ_LEVEL_PR_DETAILS,
			data: {
				rfqId: rfq.id,
				...(transporterId ? {
					transporterId,
					tripId
				} : {})
			},
			onSuccess: (data) => {
				this.setState({
					showPRPopup: true,
					PRData:  data || [],
					isTransporter: transporterId ? true : false
				})
			}
		})
	}

	onDownloadPRDetails = () => {
		const { dispatch, rfq } = this.props;
		dispatch({
			type: DOWNLOAD_PR_DETAILS,
			data: {
				rfqId: rfq.id
			},
			onSuccess: (data) => {
				if(data.url)
					downloadUrl(data.url);
			}
		})
	}

	updateStatusVisibility = () => {
		const { rfq } = this.props;
		this.setState({
			openStatusVisibilityPopup: true,
			vendorBiddingStatusObj: {
				'vendor_bidding_screen_id': (rfq.rfqDetails || {}).vendorBiddingScreenId,
				'vendor_bidding_screen': (rfq.rfqDetails || {}).vendorBiddingScreen
			}
		});
	}

	onCancelStatusVisibilityPopup = () => {
		this.setState({
			openStatusVisibilityPopup: false,
			vendorBiddingStatusObj: {}
		});
	}

	onSaveStatusVisibilityPopup = () => {
		const { dispatch, rfq } = this.props;
		const { vendor_bidding_screen_id, vendor_bidding_screen } = (this.state.vendorBiddingStatusObj || {});
		const data = {
			rfq_id: rfq.id,
			vendor_bidding_screen_id,
			vendor_bidding_screen
		}
		dispatch({
			type: UPDATE_RFQ_LEVEL_VENDOR_BIDDING_STATUS,
			data,
			onSuccess: this.getSeekerBids.bind(this)
		});
		this.onCancelStatusVisibilityPopup();
	}

	uploadOtherCharges = (file) => {
		const { dispatch, match, rfq } = this.props;
		dispatch({
			type: UPLOAD_OTHER_CHARGES,
			file : file,
			params: {
				type: 1,
				rfqId: match.params.id,
				rfqType: rfq.type,
				ipAddress: localStorage.getItem('IPAddress')
			},
			onSuccess: this.getSeekerBids
		})
	}

	downloadOtherCharges = () => {
		const { dispatch, rfq } = this.props;
		dispatch({
			type: GET_OTHER_CHARGES_TEMPLATE,
			params: {
				type: 1,
				rfqType: rfq.type,
				rfqId: rfq.id
			},
			onSuccess: (url) => {
				if(url) {
					downloadUrl(url);
				}
			}
		})
	}

	saveConvertToPreBid = () => {
		const { dispatch, rfq } = this.props;
		dispatch({
			type: UPDATE_POST_BID_TO_PRE_BID_RFQ,
			data: {
				"pre_bid_rfq_number": this.state.pre_bid_rfq_number,
    			"rfq_id": rfq.id
			},
			onSuccess: this.getSeekerBids
		});
		this.onCancelConvertToPreBid();
	}

	convertToPreBid = () => {
		this.setState({
			openPreBidPopup: true
		})
	}

	onCancelConvertToPreBid = () => {
		this.setState({
			openPreBidPopup: false,
			pre_bid_rfq_number: ''
		})
	}

	onUploadLoiDocs = (file) => {
		const  { dispatch } = this.props;
        dispatch({
            type: UPLOAD_DOCUMENT,
            file,
            onSuccess: (data) => { 
               const { loi_docs } = this.state;
               loi_docs.push(data);
               this.setState({
				loi_docs
			   });
            }
        })
	}

    downloadUploadedFile = (fileName) => {
        const { dispatch } =  this.props;
        dispatch({
           type: DOWNLOAD_UPLOADED_FILE,
           param: {
              fileName
           }
        });
    }

	deleteDoc = (index) => {
		const { loi_docs } = this.state;
		loi_docs.splice(index, 1);
		this.setState({
			loi_docs
		});
	}

	getLOIPopUPText = () => {
		const { rfq } = this.props;
		let loiText = 'You are authorised to send the LOI only for the L1 Transporters';
		if(EMAMI.includes(rfq.companyId)) {
			loiText = "Please Select only one Transporter to Send an LOI";
		} else if(CARGIL.includes(rfq.companyId)) {
			loiText = "Please Select only the transporters, to whom the other charges are added";
		} else if(BEAM.includes(rfq.companyId)) {
			loiText = "LOI Details"
		}
		return loiText;
	}

	uploadUpdatedOfflineTrips = (file) => {
		const { dispatch, match, rfq } = this.props;
		dispatch({
			type: POST_OFFLINE_CONTRACTS_UPDATED_DETAILS,
			file : file,
			params: {
				type: 1,
				rfqId: match.params.id,
				rfqType: rfq.type,
				ipAddress: localStorage.getItem('IPAddress')
			},
			onSuccess: this.getSeekerBids
		})
	}

	downloadExistingOfflineTrips = () => {
		const { dispatch, rfq } = this.props;
		dispatch({
			type: GET_OFFLINE_CONTRACTS_DETAILS_TO_UPDATE,
			params: {
				type: 1,
				rfqType: rfq.type,
				rfqId: rfq.id
			}
		});
	}

	approverBasedonPercentage = (bid) => {
		const { rfq } = this.props;
		const calPercentage = (bid.price - (rfq.lpp || 0)) / (bid.price);
		let perValue = 2;
		if(calPercentage >= 0 && calPercentage <= 2) {
			perValue =  2;
		} else if(calPercentage > 2 && calPercentage <= 5) {
			perValue = 5;
		} else if(calPercentage > 5 && calPercentage <= 15) {
			perValue = 15;
		} else if(calPercentage > 15) {
			perValue = 16;
		}
		return perValue;
	}

	handleOnClickBack = () => {
		const { history } = this.props;
		history.goBack();
	  };

	  shouldRenderBackWithLink=()=>{
		if(isBeamS() || isCoromandel()){
			return false;
		} 
		return true;
	  }
	  shouldRenderBackWithoutLink=()=>{
		//   if (isBeamS() || isCoromandel()) {
		// 	  return true;
		//   }
		//   return false;
			return true;
	  }

	isSelectedBidsAmountLess2Lakh = () => {
		const { selectedBids } = this.state;
		const totalAmount = (selectedBids || []).reduce((acc, cEle) => {
			return acc + cEle.price
		}, 0)

		const C1 = selectedBids.length > 0
		const C2 = totalAmount < 0

		if (C1 && C2) {
			return true;
		}

		return false
	}

	isSelectedBidsAmountGreaterEqTo2Lakh = () => {
		const { selectedBids } = this.state;
		const totalAmount = (selectedBids || []).reduce((acc, cEle) => {
			return acc + cEle.price
		}, 0)
		const C1 = selectedBids.length > 0
		const C2 = totalAmount > 0
		if (C1 && C2) {
			return true;
		}

		return false
	}

	shouldRenderSendLoIBtnForDesmet = (rfq, systemTime) => {
		const C1 = isDesmet()
		const C2 = this.isSelectedBidsAmountLess2Lakh()
		const C3 = rfq && rfq.rfqDetails.biddingEnd < systemTime
		if (C1 && C2 && C3) {
			this.sendAndApproverLoi ='Send LOI'
			return true;
		}
		return false;
	}

	isLogicT1Valid = () => {
		const C1 = isDesmet()
		const C2 = this.isSelectedBidsAmountGreaterEqTo2Lakh()
		if (C1 && C2) {
			return true;
		}
		return false;
	}

	updateSinglebiddedBidTime = () => {
		const { dispatch, rfq } = this.props;
		const { biddingEnd } = this.state;
		dispatch({
			type: EXTEND_BID_TIME_FOR_SINGLE_BIDDED_TRIPS,
			data: {
				"rfq_id": rfq.id,
				"trip_bidding_end": biddingEnd
			},
			onSuccess: this.getSeekerBids
		});
		this.hideChangeBidding();
	}

	shouldRenderDownloadBidTrail = (rfq,loiApproverType,systemTime) => {
		// rfq && ![10, 12, 13, 71, 72, 73].includes(this.loiApproverType) && rfq.type !== 9 && ((POLYCAB.includes(rfq.companyId) && rfq.rfqDetails.biddingEnd > systemTime) ? rfq.biddingCategoryId != 2 : true) &&  !isHikal()
		const C1 = rfq && ![10, 12, 13, 71, 72, 73].includes(loiApproverType) && rfq.type !== 9;
		const { trips } = this.props;
		const relayBidEndTime = (trips || []).length > 0 && trips[trips.length - 1].relayEndTime || 0;
		const C2 = ((rfq && (rfq.rfqDetails.biddingEnd > systemTime || (relayBidEndTime > systemTime)))
			? rfq.biddingCategoryId != 2
			: true)
		if (isHikal()) {
			return false
		}

		if (C1 && C2) {
			return true
		}

		return false
	}

	reactivateTk11 = (bid) => {
		console.log('bid', bid);
		const { dispatch, rfq } = this.props;
		dispatch({
			type: REACTIVATE_TK11,
			data: {
				rfq_id: rfq.id,
				transporter_id: bid.transporterId,
				trip_id: bid.tripId
			},
			onSuccess: this.getSeekerBids
		});
	}

	onCancelCP = (data) => {
		const { dispatch } = this.props;
		dispatch({
		   type: CANCEL_CP,
		   data,
		   onSuccess: this.getSeekerBids
		})
	 }

	handleLoiConfirm = () => {
		const { loiActionType } = this.state;
		if (loiActionType === 'SEND_LOI_APPROVER') {
			this.postLOIForApprover();
		}
	};

	isApproverAllowedForLoi = (dashboardActivestatus, rfq) => {
		const isCoro = isCoromandel();
		const isStatusNot10 = dashboardActivestatus !== 10;
		const isEmailNotApprover = !rfq?.approver_email_list?.includes(getUser().email);

		// If status 10 → always allowed
		if (!isStatusNot10) {
			return true;
		}

		// Custom Coromandel logic
		if (isCoro && rfq?.type === 6) {
			return true;
		}

		return isEmailNotApprover;
	};

	shouldShowUpdateBusinessVolume = () => {
		const selectedBids = this.state.selectedBids || [];

		// Count how many complete trips are selected
		let completeTripsCount = 0;

		(this.props.trips || []).forEach(trip => {
			const tripBids = trip.bids || [];
			if (tripBids.length === 0) return;

			// Check if all bids from this trip are in selectedBids
			const isCompleteTrip = tripBids.every(bid =>
				selectedBids.some(selectedBid => selectedBid.id === bid.id)
			);

			if (isCompleteTrip) {
				completeTripsCount++;
			}
		});

		// Show button only if: exactly 1 complete trip selected OR exactly 1 individual bid selected
		return completeTripsCount === 1 || (completeTripsCount === 0 && selectedBids.length === 1);
	}
    
	shouldShowSendLOIButton = (rfq, dashboardActivestatus, systemTime, isSentLoiApprover, isApproved, appoverApprovedDisable) => {
		// const { rfq, dashboardActivestatus, systemTime, isSentLoiApprover, isApproved, appoverApprovedDisable } = this.props;
		const { selectedBids, isSentLOiApproverDisable } = this.state;
		const user = getUser();

		if (!rfq) return false;

		if (dashboardActivestatus !== 10 && rfq.approver_email_list.includes(user.email)) {
			return false;
		}

		if (rfq.approverEmail.length === 0) return false;
		if (dashboardActivestatus === 9) return false;
		if (selectedBids.length === 0) return false;
		if (!isSentLoiApprover) return false;
		if (!(rfq.rfqDetails.biddingEnd < systemTime)) return false;
		if (isSentLOiApproverDisable) return false;
		if (isApproved) return false;
		if (appoverApprovedDisable) return false;
		if (isDesmet() && !this.isLogicT1Valid()) return false;

		return true;
	};

	render() {
		const {
			rfq,
			vehicleTypes,
			vehicleBodyTypes,
			tripsCount,
			trips,
			loadingTrips,
			challengePriceSubmitting,
			sendLoiSubmitting,
			uploadingBiddingDetails,
			downloadingBiddingDetails,
			paymentCycles,
			pricingBasis,
			systemTime,
			approverMessage,
			sendLOIForApprover,
			downloadBidTrailDetails,
			tripBids,
			courierZones,
			courierMovements,
			courierModes,
			slabList,
			transporterBidCCharges,
			maxTransportersCountRFQ,
			currencyDetails,
			fromZones,
			toZones,
			downloadBidRate,
			uploadBidRate,
			downloadTruckDetails,
			uploadTrucksDetails,
			numberOfVehiclePlaced,
			currencyTypes,
			loiCancelled,
			bided_transporter_name,
			transporters,
			vendorBiddingStatus,
			chat_menu
		} = this.props;
		const dashboardActivestatus = this.props.location.state && this.props.location.state.dashboardActiveView ? this.props.location.state.dashboardActiveView : getDashboardActiveView();
		this.state.isSentLOiApproverDisable = (dashboardActivestatus === 10);
		let appoverApprovedDisable = (dashboardActivestatus === 13);
		const isApproved = (dashboardActivestatus === 12);
		const isAproverSendMessageEnable = this.state.isSentLOiApproverDisable;
		const isChallengePriceForm = getUser().isChallengePriceForm;
		const isUploadRateEanble = getUser().uploadRate;
		const isUploadNumberOfTrucks =getUser().uploadNumberOfTrucks;
		const isEnabledClosedRfq= getUser().enabledClosedRfq;
		const isEnabledAcceptanceCeilingPrice = getUser().enabledAcceptanceCeilingPrice;
		const user = getUser();
		
		let isAtleastOneLoiSent = false;
		let isMinimumBidderApprover = true;
		let hasRelay = false;
		for (let i = 0; i < (trips || []).length; i++) {
			if (trips[i].bids && trips[i].bids.length > 0) {
				for (let j = 0; j < (trips[i].bids || []).length; j++) {
					isAtleastOneLoiSent = (trips[i].bids[j].isLoiSent === true) || (trips[i].bids[j].isAccept === true) || (trips[i].bids[j].isAccept === false);
					if (isAtleastOneLoiSent) break;
				}
			}
			if (isAtleastOneLoiSent) break;
		}

		for (let i = 0; i < (trips || []).length; i++) {
			if (trips[i].relayEndTime) {
				hasRelay = true;
				break;
			}
		}
		if (rfq && rfq.approverEmail.length === 0 && !this.state.isSentLOiApproverDisable) {
			this.state.isSentLOiApproverDisable = true;
			this.sendAndApproverLoi = `Send ${rfq.type === 8 ? 'PO' : 'LOI'}`;
		} else {
			if (rfq && rfq.loiApproverEmails.length > 0) {
				const user = getUser();
				for (let i = 0; i < rfq.loiApproverEmails.length; i++) {
					// let isLoiApproverValid = ROQUETTE.includes(getUser().companyId) ? rfq.loiApproverEmails.includes(user.email) : (rfq.loiApproverEmails[i] === user.email);
					let isLoiApproverValid = (rfq.loiApproverEmails[i] === user.email);
					if(ROQUETTE.includes(getUser().companyId) && user.isApprover && rfq.user_email === user.email && dashboardActivestatus !== 10) {
						const loiPrice = (this.state.selectedBids || []).reduce((sum, el) => (sum += (el['share_of_business_percentage']) ? (el.product_volume_price * (el['share_of_business_percentage'] / 100)) : 0), 0);
						isLoiApproverValid = (isLoiApproverValid || (loiPrice <= rfq.approver_price));
					}
					if (isLoiApproverValid) {
						this.sendAndApproverLoi = `Approve ${rfq.type === 8 ? 'PO' : 'LOI'}`;
						this.isMinimumBidderApprover =(rfq && rfq.minBidders>0)?false: true;
						this.state.isSentLOiApproverDisable = isLoiApproverValid;
						break;
					} else {
						this.state.isSentLOiApproverDisable = isLoiApproverValid;
						this.isMinimumBidderApprover =(rfq && rfq.minBidders>0)?false: true;
					}
				}

			}
		}
		if (rfq && rfq.approvalMatrixEmails.length > 0) {
			for (let i = 0; i < rfq.approvalMatrixEmails.length; i++) {
				let isLoiApproverValid = (rfq.approvalMatrixEmails[i] === user.email);
				if (isLoiApproverValid && rfq.loiApproverEmails[i] !== user.email) {
					this.appoverLevel = "Approve";
					this.isMinimumBidderApprover =(rfq && rfq.minBidders>0) ? false: true;
					break;
				} else if (!isLoiApproverValid && rfq.loiApproverEmails[i] !== user.email) {
					this.appoverLevel = `Send ${rfq.type === 8 ? 'PO' : 'LOI'} for Approver`;
					this.isMinimumBidderApprover =(rfq && rfq.minBidders>0) ? false: true;
				}
			}
		} else {
			if (rfq && rfq.approverEmail.length > 0) {
				this.appoverLevel = `Send ${rfq.type === 8 ? 'PO' : 'LOI'} for Approver`;
				this.isMinimumBidderApprover =(rfq && rfq.minBidders>0) ? false: true;
			}
			if(rfq && ROQUETTE.includes(getUser().companyId) && user.isApprover && rfq.user_email === user.email && dashboardActivestatus !== 10) {
				const loiPrice = (this.state.selectedBids || []).reduce((sum, el) => (sum += (el['share_of_business_percentage']) ? (el.product_volume_price * (el['share_of_business_percentage'] / 100)) : 0), 0);
				if(loiPrice <= rfq.approver_price) {
					this.sendAndApproverLoi = `Send ${rfq.type === 8 ? 'PO' : 'LOI'}`;
					this.isMinimumBidderApprover =(rfq && rfq.minBidders>0) ? false: true;
					this.state.isSentLOiApproverDisable = true;
				}
			}
		}
		if( ROQUETTE.includes(getUser().companyId) && rfq && rfq.approverEmail.length > 0 && dashboardActivestatus === 10) {
			const loiPrice = (this.state.selectedBids || []).reduce((sum, el) => (sum += (el['share_of_business_percentage']) ? (el.product_volume_price * (el['share_of_business_percentage'] / 100)) : 0), 0);
			const maxPrice = Math.max.apply(Math, rfq.approver_price);
			const aPrice = loiPrice < maxPrice ? rfq.approver_price.find(val => maxPrice !== val) : maxPrice;
			const levels = (rfq.approverEmail || []).filter(approver => aPrice == approver.price);
			if(levels) {
				const emails = ((levels[0] || {}).levels || []).map(level => level.emails);
				const maxEmails =  (((rfq.approverEmail || []).filter(approver => maxPrice == approver.price)[0] || {}).levels || []).map(level => level.emails);
				(emails || []).forEach(email => {
					let isLoiApproverValid = ((email.includes(getUser().email)) || (maxEmails[maxEmails.length - 1].includes(getUser().email)));
					if(isLoiApproverValid) {
						this.sendAndApproverLoi = `Approve LOI`;
						this.state.isSentLOiApproverDisable = isLoiApproverValid;
					} else {
						this.sendAndApproverLoi = `Send LOI For Approver`;
						this.state.isSentLOiApproverDisable = isLoiApproverValid;
					}
				})
			}
		}
		if(isAdaniWilmar() && rfq && rfq.type === 6) {
			this.state.isSentLOiApproverDisable = true;
			this.sendAndApproverLoi = "Send LOI";
		}
		if (isCoromandel() && rfq && rfq.type === 6) {
			this.state.isSentLOiApproverDisable = true;
			this.sendAndApproverLoi = "Send LOI";
		}
		const isSentLoiApprover = (trips && trips.length > 0 && (trips[trips.length - 1].bids.length > 0 || ((trips[trips.length - 1] || {}).legs).length > 0));
		const lastRelayTime = (trips && trips.length > 0 && trips[trips.length - 1] && trips[trips.length - 1].relayEndTime);
		//const hasLastRelayTimeEnded = (lastRelayTime && lastRelayTime < new Date().getTime());
		const hasLastRelayTimeEnded = (lastRelayTime && lastRelayTime < systemTime);
		const popUpClasses = classNames("pa mb-40 pt-20 pl-40 bg-white box-shadow pr-40 ht-500 b-20 wt-450 triangle-bottom br-5 ", {
			"r-0": true,
			"r-35p": !this.isApprovalMode && isChallengePriceForm,
		});
		const isEditContractTenure = (user.actions || []).find(action => [1,3,12].includes(action.id))
		const isEditBidTime = (user.actions || []).find(action => [1,3,5].includes(action.id))
		const isEditEnabled = (user.actions || []).find(action => [1,3].includes(action.id))
		return (

			<div  className={classNames('',{'disable-pointer-events': this.state.shareOfBusinessLoader })}>
				 <ScreenTimeTrack 
                   screenInfoDetailsItem = {
                    screenInfoDetails.RFQ_BIDS_SCREEN
                   }
                 />
				{this.state.shareOfBusinessLoader && <Loader fixed={true}/>}
				{(loadingTrips || sendLoiSubmitting || challengePriceSubmitting || uploadingBiddingDetails || downloadingBiddingDetails || sendLOIForApprover || downloadBidTrailDetails || downloadBidRate || uploadBidRate || downloadTruckDetails || uploadTrucksDetails || numberOfVehiclePlaced || loiCancelled) && <ActionLoader fixed={true} />}
				{this.state.isLoiPopupShown &&
					<ConfirmationRemarksPopup
						text={`Are You Sure You Want To Send The ${rfq.type === 8 ? 'PO' : 'LOI'}?`}
						hasInput={true}
						hasRemarks={true}
						value={this.state.remarks}
						onChange={this.onRemarksChange}
						acceptLoiFrom={this.state.acceptLoiFrom}
						acceptLoiTo={this.state.acceptLoiTo}
						focusedFrom={this.state.focusedFrom}
						focusedTo={this.state.focusedTo}
						onFocusedFrom={this.onFocusedFrom}
						onFocusedTo={this.onFocusedTo}
						onToDateChange={this.onToDateChange}
						onFromDateChange={this.onFromDateChange}
						instructionsValue={this.state.instructions}
						onChangeInstructions={this.onInstructionsChange}
						onCancel={this.hideLoiPoup}
						onConfirm={this.sendLoi}
						onSendAndApprover={this.sendAndApproverLoi}
						cpPrice={this.state.cpPrice}
						onCPChange={this.onCPChange}
						loiWithCPPrice={this.state.loiWithCPPrice}
						loiWithCPPriceChange={this.loiWithCPPriceChange}
						rfq={rfq}
						systemTime={systemTime}
						isEditable={rfq.loiPeriodApplicable}
						onUploadLoiDocs={this.onUploadLoiDocs}
						downloadUploadedFile={this.downloadUploadedFile}
						deleteDoc={this.deleteDoc}
						loi_docs={this.state.loi_docs || []}
					/>}

				{this.state.isSendApproverPopupShown &&
					<ConfirmationRemarksPopup
						text={'Are You Sure You Want To Send The LOI?'}
					    tk11_type_name={isCoromandel() ? rfq.rfqDetails.tk11_type_name : ""}
						hasInput={true}
						hasRemarks={true}
						value={this.state.remarks}
						onChange={this.onRemarksChange}
						acceptLoiFrom={this.state.acceptLoiFrom}
						acceptLoiTo={this.state.acceptLoiTo}
						focusedFrom={this.state.focusedFrom}
						focusedTo={this.state.focusedTo}
						onFocusedFrom={this.onFocusedFrom}
						onFocusedTo={this.onFocusedTo}
						onToDateChange={this.onToDateChange}
						onFromDateChange={this.onFromDateChange}
						instructionsValue={this.state.instructions}
						onChangeInstructions={this.onInstructionsChange}
						onCancel={this.hideSendLoiPoup}
						onConfirm={this.handleLoiConfirm}
						onSendAndApprover={this.appoverLevel}
						cpPrice={this.state.cpPrice}
						onCPChange={this.onCPChange}
						loiWithCPPrice={this.state.loiWithCPPrice}
						loiWithCPPriceChange={this.loiWithCPPriceChange}
						rfq={rfq}
						systemTime={systemTime}
						isEditable={rfq.loiPeriodApplicable}
						onUploadLoiDocs={this.onUploadLoiDocs}
						downloadUploadedFile={this.downloadUploadedFile}
						deleteDoc={this.deleteDoc}
						loi_docs={this.state.loi_docs || []}
				/>}
				{this.state.isLoiApproverPopupShown &&
					<ApproverConfirmationPopup
						text={this.state.loiApproverPopupType === 2 ? 'Reject Remarks' : 'Let Us Discuss'}
						placeholder={this.state.loiApproverPopupType === 2 ? "Remarks" : "Message"}
						loiApproverPopupType={this.state.loiApproverPopupType}
						hasInput={this.state.loiApproverPopupType === 1}
						value={this.state.approverLoiRemarks}
						onChange={this.onApproverMessageChange}
						onConfirm={this.sendApproverMessageForUser}
						onCancel={this.hideLoiApproverPoup}
						errorMessage={this.state.errorMessage}
						hasRemarks={this.state.loiApproverPopupType === 2}
					/>}
				<Sticky>
					<div className="pr">

						{/* {rfq && this.shouldRenderBackWithLink() && <Link className="ht-30 flex flex-middle pl-40 wt-max-content mb-10 mt-5" to={"/"}>
							<BackIcon className="mr-10 fill-theme curP" />
							<div className="flex flex-bottom">
								{rfq.rfqDetails.name && <div className="header-dark-color fs-16 fBold wt-50p">{rfq.rfqDetails.name}</div>}
								<div className="ml-5 table-text-color fRegular fs-12 op-79 lh-15p">RFQ {rfq.rfqNumber}</div>
							</div>
						</Link>} */}
						{rfq && this.shouldRenderBackWithoutLink() &&
							<div className="ht-30 flex flex-middle pl-40 wt-max-content mb-10 mt-5">
								<BackIcon
									className="mr-10 fill-theme curP"
									onClick={this.handleOnClickBack}
								/>

								<div className="flex flex-bottom">
									{rfq.rfqDetails.name && (
										<div className="header-dark-color fs-16 fBold wt-50p">
											{rfq.rfqDetails.name}
										</div>
									)}

									<div className="ml-5 table-text-color fRegular fs-12 op-79 lh-15p wt-200 flex flex-middle">
										RFQ {rfq.rfqNumber}

										<span
											className="ml-10 curP flex flex-middle"
											title="Copy RFQ Number"
											onClick={this.handleCopyRfqNumber}
										>
											{this.state.isRfqCopied
												? <MdCheck size={16} className="success-color" />
												: <MdContentCopy size={16} />
											}
										</span>
									</div>
								</div>
								{/* {isVishaka() && <div className="flex flex-middle ml-20">
									<a
										href={`https://lookerstudio.google.com/embed/reporting/37d85d19-c828-43be-8bc4-6d96c9ab146d/page/p_jlp47aoh2d?params=${encodeURIComponent(JSON.stringify({ rfq_number_param: rfq.rfqNumber }))}`}
										target="_blank"
										rel="noopener noreferrer"
										className="fs-14 fSemibold contract-summary-link curP"
									>
										Contract Summary
									</a>
								</div>} */}
							</div>
						}
						{rfq && !this.isApprovalMode && <div className="flex ht-40 flex-middle pl-10 mb-10 pa r-35p t-0">
							<Link to={"/seeker/bids/" + rfq.id + "/" + rfq.type} className="fBold header-dark-color border-bottom-theme-4 fs-16 row-100 mr-40 flex flex-middle">Bids</Link>
							<Link to={"/seeker/bids/transporters/list/" + rfq.id} className="fSemibold header-medium-color fs-16 row-100 flex flex-middle curP">{HIKAL.includes(getUser().companyId) ? 'Recipients' : (rfq.type === 9 ? 'Buyers' : 'Transporters')}</Link>
						</div>}

						{rfq && <div className={classNames("mr-15 ml-15 ph-20 pv-10 mb-20 br-5 pa r-10 t-0 bg-white z-6", { 'box-shadow': this.state.isRFQDetailsShown })}>
							<div className="flex flex-between flex-middle fs-22 header-dark-color fSemibold">
								<span className="mr-10 curP flex mr-30 fs-16" onClick={this.toggleRFQDetails}>RFQ Details<span className="triangle ml-10 rotate-180"></span></span>
								<span className="flex-1"></span>
								{
									!isAtleastOneLoiSent && isEditEnabled &&
									<React.Fragment>
										<div className="flex flex-middle mr-30" onClick={() => { this.setState({ showCancelPopup: true, cancelRFQRemarks: '' }) }}>
											<CancelIcon className="ht-15 wt-15 t-2 mr-5 curP" />
											<div className="pr fs-14 theme-color curP t-2">Cancel RFQ</div>
										</div>
										{
											this.state.showCancelPopup &&
											<ConfirmationPopup
												text={'Are you sure you want you cancel the RFQ?'}
												onConfirm={() => this.handleRFQCancellation(rfq.id, rfq.type)}
												onCancel={() => { this.setState({ showCancelPopup: false, cancelRFQRemarks: '' }) }}
												hasRemarks={true}
												placeholder={'Remarks'}
												remarksMandatory={true}
												loiRejectionReason={this.state.cancelRFQRemarks}
												onChangeLoiRejectionRemarks={(e) => {
													this.setState({
														cancelRFQRemarks: e.target.value
													})
												}}
											/>
										}
									</React.Fragment>
								}
								{rfq && BEAM.includes(rfq.companyId) && rfq.rfqDetails.biddingEnd < systemTime && (rfq.loi_document || []).length > 0 && 
									<div className="flex flex-middle mr-30" 
										onClick={() => this.setState({ viewUploadedFiles: true })}
									>
									<div className="pr fs-14 theme-color curP t-2">View Uploaded Files</div>
								</div>}
								{rfq && CARGIL.includes(rfq.companyId) && rfq.rfqDetails.biddingEnd < systemTime && <div className="flex flex-middle mr-30" onClick={() => this.showPRDetails()}>
									<div className="pr fs-14 theme-color curP t-2">View PR Details</div>
								</div>}
								<Link to={`${[12,13,14,15].includes(rfq.type) ? '/exim/rfq/view/' : '/rfq/view/'}` + rfq.id + "/" + rfq.rfqDetails.serviceType + "/" + rfq.type} className="flex flex-middle">
									<OpenIcon className="ht-15 wt-15 mr-5 curP" />
									<div className="pr fs-14 theme-color curP t-2">Open RFQ</div>
								</Link>
							</div>
							{this.state.isRFQDetailsShown && <div className="flex mt-20">
								<div className="flex flex-column mr-50">
									<div className="flex header-dark-color fSemibold fs-16 mb-10">
										<div className="fs-16 mr-10 wt-100">Floated</div>
										<div className="fs-16 wt-150">{rfq.rfqDetails.floated}</div>
									</div>
									<div className="flex header-dark-color fSemibold fs-16 mb-10">
										<div className="fs-16 mr-10 wt-100">Floated By</div>
										<div className="fs-16 wt-150">{rfq.rfqDetails.floatedBy}</div>
									</div>
									<div className="flex header-dark-color fSemibold fs-16">
										<div className="fs-16 mr-10 wt-100">Floated On</div>
										<div className="fs-16 wt-150">{Moment(rfq.created).format("DD MMM YYYY")}</div>
									</div>
								</div>
								<div className="flex flex-column">
									<div className="flex header-dark-color fSemibold fs-16 mb-10">
										<span className="fs-16 mr-10 wt-150">Contract tenure</span>
										<span className="fs-16">{Moment(rfq.rfqDetails.contractTenureFrom).format('DD MMM YYYY') + ' - ' + Moment(rfq.rfqDetails.contractTenureTo).format('DD MMM YYYY')}</span>
									</div>
									<div className="flex header-dark-color fSemibold fs-16">
										<span className="fs-16 mr-10 wt-150">RFQ Name</span>
										<span className="fs-16">{rfq.rfqDetails.name}</span>
									</div>
									{rfq.type !== 1 && <div className="flex header-dark-color fSemibold fs-16 mt-10">
										<span className="fs-16 mr-10 wt-150">Other Costs</span>
										<span className="fs-16">{rfq.includesOtherCharges === true ? "Includes" : "Excludes"}</span>
									</div>}
								</div>
							</div>}
						</div>}
						{this.state.approverMsg && !this.state.isSentLOiApproverDisable && !isApproved && ![10, 12, 13, 71, 72, 73].includes(this.loiApproverType) && <div className="box-shadow mr-15 ml-15 ph-60 pv-20 mb-20 br-5">
							<span className="mr-10 curP orange-color fSemibold" >Approver Message:</span>
							<span>{this.state.approverMsg}</span>
						</div>
						}
						{rfq &&
							<SeekerBidsTable
								rfq={rfq}
								dashboardActiveView={dashboardActivestatus}
								setBids={this.setBids}
								trips={trips}
								fetchTrips={this.refreshSeekerBids}
								offset={0}
								showPagination={false}
								vehicleTypes={vehicleTypes}
								vehicleBodyTypes={vehicleBodyTypes}
								tripsCount={tripsCount}
								loadingTrips={loadingTrips}
								selectedBids={this.state.selectedBids}
								paymentCycles={paymentCycles}
								pricingBasis={pricingBasis}
								isApprovalMode={this.isApprovalMode}
								postBid={this.postBid}
								hideTransportersName={rfq.hideTransportersName}
								displayBaseVolume={rfq.displayBaseVolume}
								postChallengePrice={this.postChallengePrice}
								deleteTripDetails={this.deleteTripDetails}
								submitPrice={this.sendChallengePrice}
								submitOtherCostPrice={this.sendOtherCostChallengePrice}
								systemTime={systemTime}
								tripBids={tripBids}
								fetchBids={this.fetchBids.bind(this)}
								courierZones={courierZones}
								courierMovements={courierMovements}
								courierModes={courierModes}
								slabList={slabList}
								fetchTranspBidCommonCharges={this.fetchTranspBidCommonCharges}
								transporterBidCCharges={transporterBidCCharges}
								maxTransportersCountRFQ={maxTransportersCountRFQ}
								currencyDetails={currencyDetails}
								fromZones={fromZones}
								toZones={toZones}
								isCancelRFQ={this.state.showCancelPopup}
								saveNumberOfVehiclePlaced ={this.saveNumberOfVehiclePlaced}
								currencyTypes={currencyTypes}
								revokeWithdrawBid ={this.revokeWithdrawBid}
								getVehicleTypes={this.getVehicleTypes}
								postSOB={this.postSOB}
								bided_transporter_name={bided_transporter_name}
								selectTrip={this.selectTrip}
								approverMessage={this.state.approverMsg}
								showPRDetails={this.showPRDetails}
								transporters={transporters}
								getSeekerTransporters={this.getSeekerTransporters}
								reactivateTk11={this.reactivateTk11}
								onCancelCP={this.onCancelCP}
								loiApproverType={this.loiApproverType}
							    getSeekerBids={this.getSeekerBids}
							/>
						}

						
						<div className="pl-40 pf col-1 b-0 ht-60 box-shadow bg-white z-6">
							<div className="flex flex-middle flex-between ht-60">
							{rfq && this.state.isChangeBidShown &&
								<div className="pa mb-10 pt-20 pl-40 bg-white box-shadow pr-40 ht-500 b-20 wt-450 triangle-bottom br-5">
									<CloseIcon className="pa t--15 r--15 curP" onClick={this.hideChangeBidding} />
									<SingleDatePicker
										noBorder={true}
										displayFormat={"DD MMM YYYY"}
										isOutsideRange={() => false}
										hideKeyboardShortcutsPanel={true}
										placeholder={"Bidding End"}
										numberOfMonths={1}
										date={Moment(this.state.biddingEnd ? this.state.biddingEnd : rfq.rfqDetails.biddingEnd)}
										onDateChange={(biddingEnd) => {
											const date = biddingEnd.format('YYYY-MM-DD') + ' ' + Moment(this.state.biddingEnd ? this.state.biddingEnd : rfq.rfqDetails.biddingEnd).format('HH:mm')
											this.setState({ biddingEnd: new Date(date).getTime() });
										}}
										focused={true}
										onFocusChange={({ focused }) => this.setState({ focusedStart: focused })}
									/>
									<TimePicker
										showSecond={false}
										defaultValue={Moment(this.state.biddingEnd ? this.state.biddingEnd : rfq.rfqDetails.biddingEnd)}
										value={Moment(this.state.biddingEnd)}
										className="ht-40 wt-150 border-status-bar br-5"
										onChange={(biddingEnd) => {
											const date = Moment(this.state.biddingEnd ? this.state.biddingEnd : rfq.rfqDetails.biddingEnd).format('YYYY-MM-DD') + ' ' + biddingEnd.format('HH:mm')
											this.setState({ biddingEnd: new Date(date).getTime() });
										}}
										format={'h:mm a'}
										use12Hours
										inputReadOnly
									/>
									<button className="pa b-20 ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 hCenter" onClick={this.state.isTriplevel ? this.postTripBidEndTime : this.updateBiddingEnd}>Update</button>
								</div>}
							<div className="flex flex-middle ml-20">
								{rfq && this.state.isTimerShown && <Timer from={rfq.rfqDetails.biddingStart} to={rfq.rfqDetails.biddingEnd} currentTime={systemTime} />}
								{rfq && dashboardActivestatus !== 9 && !isAtleastOneLoiSent && !rfq.isRfqClosed && ![10, 12, 13, 71, 72, 73].includes(this.loiApproverType) && (ROQUETTE.includes(rfq.companyId) ? (this.state.selectedBids.length === 0) : true) && (user.edit_bidding_time || user.isAdmin || isEditBidTime) && <div className="theme-color fs-14 fSemibold ml-20 curP t-3 pr" onClick={this.showChangeBidding}>Change Bid End Time</div>}

							</div>
							{rfq && isFosroc() && <div className="flex flex-middle ml-20">
								{rfq && dashboardActivestatus !== 9 && !rfq.rfq_re_bidding_end && !rfq.isRfqClosed && ![10, 12, 13, 71, 72, 73].includes(this.loiApproverType) && <div className="theme-color fs-14 fSemibold ml-20 curP t-3 pr" onClick={() => this.showChangeBidding('', true)}>Change Bid End Time For Single Bided Trips</div>}
							</div>}
							{ rfq && (rfq.event_contract || STAR_CEMENT.includes(rfq.companyId)) &&
								<div className="fBold fs-16">
									<span className='theme-color'>Bid Extension:</span> <span className={'orange-color'}>{rfq.bid_extension_count}</span> / <span className='success-color'>{rfq.totalBidExtension}</span>
								</div>
							}
							{rfq && this.state.selectedTrip.length === 1 &&
									([...DEEPAK_PHENOLICS_SAP, ...DEEPAK_PHENOLICS].includes(rfq.companyId)) &&
									(rfq?.is_rfq_price_update || rfq?.is_rfq_toll_price_update) &&
									(
										<div className="flex flex-middle ml-10">
											<button
											    className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30"
												onClick={this.rfqTollUpdatePrice}
											>
												Revised Price Update
											</button>
										</div>
									)
							}
							{rfq && this.state.selectedTrip.length > 0 && ![10, 12, 13, 71, 72, 73].includes(this.loiApproverType) && !isAtleastOneLoiSent && <div className="flex flex-middle ml-10"><button class="theme-color fs-14 fSemibold ml-20 curP t-3 pr" onClick={() => this.showChangeBidding('', true)}>Change Trips Bid End Time</button></div>}
							{rfq && ([...BEAM, ...ROQUETTE, ...DEEPAK_PHENOLICS_SAP, ...DEEPAK_PHENOLICS, ...COROMANDEL, ...VISHAKA].includes(rfq.companyId) || isAdaniWilmar()) && this.state.selectedBids.length > 0 && (([...BEAM, ...DEEPAK_PHENOLICS_SAP, ...DEEPAK_PHENOLICS, ...COROMANDEL, ...VISHAKA].includes(rfq.companyId) || isAdaniWilmar()) ? [5].includes(this.loiApproverType) : [9].includes(this.loiApproverType)) && isEditContractTenure && <div className="flex flex-middle ml-10"><button class="theme-color fs-14 fSemibold ml-20 curP t-3 pr" onClick={this.extendContractTenure}>Extend Contract Tenure</button></div>}
							{isVishaka() && rfq && this.shouldShowUpdateBusinessVolume() &&
								<div className="flex flex-middle ml-10">
									<button
									    class="theme-color fs-14 fSemibold ml-20 curP t-3 pr"
										onClick={this.updateBusinesVolume}>
										Update Business Volume
									</button>
								</div>
							}
							<div className="flex flex-middle ml-10">
								{isAproverSendMessageEnable && <button class="sec-teg-color white-color ht-40 br-20 fs-16 fBold wt-150 curP t-3 pr" onClick={() => this.showLoiApproverPopup(1)}>Let Us Discuss</button>}
							</div>
							{rfq && RAJPETRO.includes(rfq.companyId) && <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={this.downloadBiddingSeekerTrailDetails}>Download Bid Trail</button>}
							{isAproverSendMessageEnable && this.state.selectedBids.length > 0 && <button class="ht-40 br-20 white-color bg-error fs-16 fBold pl-30 pr-30 mr-30" onClick={() => this.showLoiApproverPopup(2)}>Reject LOI</button>}
							{this.state.isChallengePriceShown && isEditEnabled && <ClickOutside handleClickOutside={() => { if(rfq && !(rfq.cpAcceptorRejectTime)) this.hideChallengePrice() }}><div className="pa b-70 mt--2 r-140"><ChallengePriceTooltip submitPrice={this.sendChallengePrice} currencyDetails={currencyDetails} rfqType={rfq && rfq.type} systemTime={systemTime} isCPAcceptValidity={rfq && rfq.cpAcceptorRejectTime} hideChallengePrice={this.hideChallengePrice}/></div></ClickOutside>}

							{rfq && this.state.isChangeSpecificBidShown && this.state.selectedBids.length > 0 && isEditEnabled &&
								<div className={popUpClasses}>
									<CloseIcon className="pa t--15 r--15 curP" onClick={() => this.hideChangeBidding('isChangeSpecificBidShown')} />
									<SingleDatePicker
										noBorder={true}
										displayFormat={"DD MMM YYYY"}
										isOutsideRange={() => false}
										hideKeyboardShortcutsPanel={true}
										placeholder={"Bidding End"}
										numberOfMonths={1}
										date={Moment(this.state.biddingEnd ? this.state.biddingEnd : rfq.rfqDetails.biddingEnd)}
										onDateChange={(biddingEnd) => {
											const date = biddingEnd.format('YYYY-MM-DD') + ' ' + Moment(this.state.biddingEnd ? this.state.biddingEnd : rfq.rfqDetails.biddingEnd).format('HH:mm')
											this.setState({ biddingEnd: new Date(date).getTime() });
										}}
										focused={true}
										onFocusChange={({ focused }) => this.setState({ focusedStart: focused })}
									/>
									<TimePicker
										showSecond={false}
										defaultValue={Moment(this.state.biddingEnd ? this.state.biddingEnd : rfq.rfqDetails.biddingEnd)}
										value={Moment(this.state.biddingEnd)}
										className="ht-40 wt-150 border-status-bar br-5"
										onChange={(biddingEnd) => {
											const date = Moment(this.state.biddingEnd ? this.state.biddingEnd : rfq.rfqDetails.biddingEnd).format('YYYY-MM-DD') + ' ' + biddingEnd.format('HH:mm')
											this.setState({ biddingEnd: new Date(date).getTime() });
										}}
										format={'h:mm a'}
										use12Hours
										inputReadOnly
									/>
									<button className="pa b-20 ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 hCenter" onClick={this.postBid}>Update</button>
								</div>}
							{!this.isApprovalMode && rfq && !isAtleastOneLoiSent && this.state.selectedBids.length > 0 && ((ROQUETTE.includes(rfq.companyId)) ? this.state.selectedTrip.length === 0 : true) && rfq.rfqDetails.biddingEnd < systemTime && ((hasRelay && hasLastRelayTimeEnded) || !hasRelay) && ![10, 12, 13, 71, 72, 73].includes(this.loiApproverType) && isEditBidTime &&
								<div className="mr-30 theme-color fs-14 fSemibold curP" onClick={() => this.showChangeBidding('isChangeSpecificBidShown')}>Change Specific Bid Time</div>
							}

							{rfq && rfq.type === 8 && ![10, 12, 13, 71, 72, 73].includes(this.loiApproverType) && 
								<> 
									{
										(rfq.rfqDetails || {}).biddingEnd < systemTime && 
										<button className="ht-40 br-20 theme-color border-theme fs-16 fBold wt-200 mr-30" onClick={() =>{
											localStorage.setItem('teg-component', true);
											location.href = "/comparativeFormat/" + rfq.id + "/" + rfq.type;
										}}>Comparative Format</button>
										// <Link to={"/comparativeFormat/" + rfq.id + "/" + rfq.type} className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 pt-10 mr-30 tCenter">Comparative Format</Link>
									}
									<Pdf targetRef={pdfRef} filename="PR_format.pdf" options={{
										orientation: 'landscape'
									}}>
										{({ toPdf }) => <button className={"ht-40 br-20 theme-color border-theme fs-16 fBold wt-150 mr-30"} onClick={toPdf}>Download PR</button>}
									</Pdf>
								</>
							}

							{rfq && rfq.rfqDetails.biddingEnd < systemTime && this.state.selectedBids.length > 0 && !appoverApprovedDisable && <>
								{!this.isApprovalMode && rfq.type === 1 && isChallengePriceForm && isEditEnabled && <Link to={"/challengepriceform/" + rfq.id} className="mr-30 theme-color fs-14 fSemibold">Challenge Price Form</Link>}
								{!this.isApprovalMode && dashboardActivestatus !== 9 && !isApproved && ![6, 9].includes(rfq.type) && isEditEnabled && ![10, 12, 13, 71, 72, 73].includes(this.loiApproverType) &&  <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={this.showChallengePrice}>Challenge Price</button>}
								{
									rfq.minBidders !== 0 && !this.selectedTripsHasMinBidders() && this.isMinimumBidderApprover
										?
										<React.Fragment>
											<span data-tip='custom show' data-event='click focus' data-for='seeker-loi-tooltip' className={'curP'}>
												<button style={{ 'pointerEvents': 'none' }} className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={this.showLoiPopup} disabled={!this.selectedTripsHasMinBidders()}>{`Send ${rfq.type === 8 ? 'PO' : 'LOI'}`}</button>
											</span>
											<ReactTooltip globalEventOff='click' place="top" id='seeker-loi-tooltip' type="dark" effect="solid">
												<span> Trip Does Not Have Defined Number Of Min Bidders To Send LOI. </span><br />
											</ReactTooltip>
										</React.Fragment>
										:
										this.state.isSentLOiApproverDisable && !isApproved && this.isEnableSendLoi() && dashboardActivestatus !== 9 && this.isApproverAllowedForLoi(dashboardActivestatus,rfq) && <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-10" onClick={this.showLoiPopup}>{this.sendAndApproverLoi}</button>
								}
							</>
							}
							{rfq && (rfq && rfq.rfqStatus === 5) && isEditEnabled && ROQUETTE.includes(user.companyId) && ![10, 12, 13, 71, 72, 73].includes(this.loiApproverType) && (rfq.rfqDetails || {}).biddingType == 1 && <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-18 pr-20 mr-30" onClick={this.convertToPreBid}>Link To Pre-Bid</button>}
                            {rfq && (rfq && rfq.rfqStatus === 5) && isUploadRateEanble && this.state.selectedBids.length=== 0 && !rfq.offline_contract && <div>
								{
									rfq && isEditEnabled &&
									<Upload onChange={this.uploadBiddingRatePopUp}>
										<button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-15 pr-20 mr-30" >Upload Rate</button>
									</Upload>}
								<button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-18 pr-20 mr-30" onClick={this.downloadBiddingRate}>Download Rate</button>
								
							</div>}
							{
								rfq && dashboardActivestatus === 5 && [...ROQUETTE, ...BEAM].includes(user.companyId) && 
								<>
									{isEditEnabled &&
									<Upload onChange={this.uploadSOBDetails}>
										<button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-15 pr-20 mr-10" >Upload SOB</button>
									</Upload>}
									<button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-18 pr-20 pl-20 mr-10" onClick={this.downloadSOBTemplate}>Download SOB</button>
								</>
							}
							{
								rfq && rfq.type === 3 && dashboardActivestatus === 5 && rfq.secondaryContractType === 2 && 
								<>
									{isEditEnabled &&
									<Upload onChange={this.uploadSlabWiseOfflineTrips}>
										<button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-15 pr-20 mr-10" >Upload Offline Trips</button>
									</Upload>}
									<button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-18 pr-20 pl-20 mr-10" onClick={this.downloadSlabWiseOfflineTrips}>Download Offline Trips</button>
								</>
							} 
							{
								rfq && rfq.offline_contract && [...DEEPAK_PHENOLICS, ...DEEPAK_PHENOLICS_SAP].includes(rfq.companyId) && rfq.rfqDetails.biddingEnd < systemTime &&
								<>
									{isEditEnabled &&
									<Upload onChange={this.uploadUpdatedOfflineTrips}>
										<button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-15 pr-20 mr-10" >Upload Updated Offline Trips</button>
									</Upload>}
									<button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-18 pr-20 pl-20 mr-10" onClick={this.downloadExistingOfflineTrips}>Download Offline Trips</button>
								</>
							} 
							{
								rfq && CARGIL.includes(rfq.companyId) && rfq.rfqDetails.biddingEnd < systemTime &&
								<>
									{isEditEnabled &&
									<Upload onChange={this.uploadOtherCharges}>
										<button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-15 pr-20 mr-10" >Upload Other Charges</button>
									</Upload>}
									<button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-18 pr-20 pl-20 mr-10" onClick={this.downloadOtherCharges}>Download Other Charges</button>
								</>
							} 
							{this.state.showCancelPopup &&  isUploadRateEanble && (rfq && rfq.rfqStatus === 5) &&
                               <ConfirmationPopup
                             text={'Caution: Please note this action will overwrite the earlier Bids in this RFQ and will be recorded in the Bid History. You may not be able to revert back to previous bids.Do you want to proceed?'}
                                    onConfirm={this.uploadUpdateRate}
                                    onCancel={() => { this.setState({ showCancelPopup: false , updatedRateFile : ""}) }}
                                   />
							 }

                             {rfq && (rfq.rfqStatus === 5) && isUploadNumberOfTrucks && this.state.selectedBids.length=== 0 && <div>
								
								{rfq && isEditEnabled &&
									<Upload onChange={this.uploadNumberOfTrucksPopUp}>
										<button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-8 pr-16 mr-30" >Upload Trucks</button>
									</Upload>}
								<button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-8 pr-18 mr-30" onClick={this.downloadTrucksDetails}>Download Trucks</button>
								
							</div>}
							
							{rfq && (['737'].includes(getUser().companyId) ? (rfq.rfqStatus === 8) : (rfq.rfqStatus === 5)) && isEnabledClosedRfq && <div>
								{this.state.isClosedRfqPopUp && <ConfirmationPopup
                                 text={'Are You Certain You Want To Close Rfq? If you close Rfq, you will not be able to extend it.'}
                                onConfirm={this.rfqClosed}
								onCancel={() => { this.setState({ isClosedRfqPopUp: false}) }}
                               />}
								<button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-8 pr-18 mr-5 ml-5" onClick={this.closedRfqPopUp}>{['737'].includes(getUser().companyId) ? 'Close RFQ' : 'Closed Bidding'}</button>
							</div>}

							{rfq && (rfq.rfqStatus === 5) && isEnabledAcceptanceCeilingPrice && <div>
	                        <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-8 pr-18 mr-30" onClick={this.acceptanceCeilingPrice}>Acceptance</button>
                            </div>}

							{ this.state.isTruckUpload && 
                              <ConfirmationPopup
                                 text={'Are You Sure You Want To Upload An Excel?'}
                                onConfirm={this.uploadNumberOfTrucks}
								onCancel={() => { this.setState({ isTruckUpload: false , updatedNumberOfTruckFile : ""}) }}
                               />
							}
							{rfq && user.selectFields.includes('retrigger_tk11') && isEditEnabled &&
							 	<button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-5 ml-5" onClick={this.onRetriggerTK11}>{'Retrigger TK11'}</button>
							}
							{rfq && rfq.liveBidTransporterAddition && rfq.rfqDetails.biddingEnd > systemTime && isEditEnabled &&
							 	<button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-5 ml-5" onClick={this.onClickAddTransporters}>{'Add Transporters'}</button>
							}
							{CARGIL.includes(getUser().companyId) && isEditEnabled && rfq && this.state.selectedBids.length > 1 && rfq.rfqDetails.biddingEnd > systemTime && (this.state.selectedBids || []).filter(bid => bid.isWithDrawBid && !bid.isAccessBidWithdrawn).length > 1 && <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-10" onClick={this.revokeMultipleWithdrawBid}>{'Revoke Bid'}</button>}
							{CARGIL.includes(getUser().companyId) && isEditEnabled && <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-10" onClick={this.updateStatusVisibility}>{'Update Status Visibility'}</button>}
							{[...CARGIL, ...ROQUETTE, ...BEAM].includes(getUser().companyId) && isEditEnabled && rfq && (this.state.selectedBids || []).filter(bid => (!bid.isSentDPHApprover || bid.isDPHApproved)).length > 0 && rfq.rfqDetails.biddingEnd < systemTime && (ROQUETTE.includes(getUser().companyId) ? [9].includes(this.loiApproverType) : true) && ![13,14,15].includes(rfq.type) && <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-10" onClick={this.openUpdateDPHPopup}>{`Update ${CARGIL.includes(getUser().companyId) ? 'PR' : 'DPH'}`}</button>}
							{rfq && rfq.rfqDetails.biddingEnd < systemTime && this.state.selectedBids.length === 0 && !this.isApprovalMode && !appoverApprovedDisable && <div className="flex">
								{!this.isApprovalMode &&  ![7,2].includes(rfq.type) && isChallengePriceForm && isEditEnabled &&
								// <Link to={"/challengepriceform/" + rfq.id} className="mr-30 theme-color fs-14 fSemibold">Challenge Price Form</Link>
								<div className="mr-30 theme-color fs-14 fSemibold pt-15 curP" onClick={() => {
									const { dispatch } = this.props;
									dispatch({
										type: CLEAR_FETCH_SEEKER_BIDS
									})
									localStorage.setItem('teg-component', true);
									location.href = "/challengepriceform/" + rfq.id;
								}}>Challenge Price Form</div>
								}
								{
									rfq && ![10, 12, 13, 71, 72, 73].includes(this.loiApproverType) &&  rfq.type !== 9 &&  isEditEnabled &&//rfq.rfqDetails.biddingEnd > systemTime &&  
									<Upload onChange={this.uploadBiddingDetails}>
										<button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" >Upload</button>
									</Upload>}
									{![10, 12, 13, 71, 72, 73].includes(this.loiApproverType) && ![13, 14, 15, 9].includes(rfq.type) && !isHikal() &&
										<button
											className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30"
											onClick={this.downloadBiddingDetails}
										>
											{`Download ${rfq.type === 8 ? 'Material Details' : 'Trips'}`}
										</button>
									}

								</div>}
								{this.shouldRenderDownloadBidTrail(rfq, this.loiApproverType, systemTime) &&  ![13, 14, 15].includes(rfq.type) &&
									<button
										className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30"
										onClick={this.downloadBiddingSeekerTrailDetails}
									>
										Download Bid Trail
									</button>}
							{ROQUETTE.includes(getUser().companyId) && rfq && this.state.selectedBids.length > 0 && rfq.rfqDetails.biddingEnd < systemTime && ![9, 71, 72, 73].includes(dashboardActivestatus) && <div className='fs-14 fBold mr-5'>LOI Price : <span className='error-color'>{numberWithCommas(Math.floor((this.state.selectedBids || []).reduce((sum, el) => (sum += (el['share_of_business_percentage']) ? (el.product_volume_price * (el['share_of_business_percentage'] / 100)) : 0), 0)))}</span></div>}
							{[...ROQUETTE].includes(getUser().companyId) && rfq && this.state.selectedBids.length > 0 && rfq.rfqDetails.biddingEnd < systemTime && [9, 71, 72, 73].includes(dashboardActivestatus) && <div className='fs-14 fBold mr-5'>DPH Price : <span className='error-color'>{numberWithCommas(Math.floor((this.state.selectedBids || []).reduce((sum, el) => (sum += (el['share_of_business_percentage'] && el.revised_price && (dashboardActivestatus === 9  ? (!el.isSentDPHApprover && !el.isDPHApproved) : true)) ? (this.getRevisedVolumePrice(el) * (el['share_of_business_percentage'] / 100)) : 0), 0)))}</span></div>}
                            {isCoromandel() && rfq && (dashboardActivestatus !== 10 ? ((rfq.approver_email_list.includes(getUser().email))) : true) && rfq.approverEmail.length > 0 && dashboardActivestatus !== 9 && this.state.selectedBids.length > 0 && isSentLoiApprover && rfq.rfqDetails.biddingEnd < systemTime && !this.state.isSentLOiApproverDisable && !isApproved && !appoverApprovedDisable &&
							<button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={this.openSendLoiApproverPopup}>{this.appoverLevel}</button>
							}
							{this.shouldShowSendLOIButton(rfq, dashboardActivestatus, systemTime, isSentLoiApprover, isApproved, appoverApprovedDisable) && 
							<button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30" 
							onClick={this.openSendLoiApproverPopup}
							>
							{this.appoverLevel}
							</button>
							}
							{rfq  && dashboardActivestatus !== 9 && (dashboardActivestatus !== 10 ? !(rfq.approver_email_list.includes(getUser().email)) : true)  && (rfq.type===2 || rfq.type===1 || rfq.type === 8) && rfq.approverEmail.length > 0 && this.state.selectedBids.length > 0  && !isSentLoiApprover && rfq.rfqDetails.biddingEnd < systemTime && !this.state.isSentLOiApproverDisable && !isApproved && !appoverApprovedDisable && <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={() => this.sendLOIForApprover()}>{this.appoverLevel}</button>
							}
							{!CARGIL.includes(getUser().companyId) && rfq  && (rfq.type===2 || rfq.type===1 || rfq.type === 8) && rfq.approverEmail.length > 0 && (this.state.selectedBids || []).length > 0 && (this.state.selectedBids || []).filter(bid => bid.isAccept && bid.dph_percentage && (dashboardActivestatus === 9 ? (!bid.isSentDPHApprover && !bid.isDPHApproved) : true)).length > 0 && rfq.rfqDetails.biddingEnd < systemTime && this.getDPHApprovalText() && <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={() => this.sendDPHForApprover()}>{this.getDPHApprovalText()}</button>
							}

									{this.shouldRenderSendLoIBtnForDesmet(rfq, systemTime) && <Fragment>
										<button
											className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30"
											onClick={this.showLoiPopup}
										>
											{this.sendAndApproverLoi}
										</button>
									</Fragment>}

							<a href={this.state.downloadBiddingDetailsUrl} className="dNone" ref={(ref) => { this.downloadBiddingDetailsButton = ref; }}>Download Bidding Details</a>
							</div>
							{rfq && rfq.type === 8 && <PRFormat pdfRef={pdfRef} rfq={rfq} trips={trips}/>}
						</div>

						{
							rfq &&  rfq.chatBoxEnable && isEditEnabled && <Chat rfq={rfq} userType={SEEKER} userId={"seeker"} chatMenu={chat_menu}/>

						}
					</div>
					{
						this.state.sobAllocationPopUp &&
						<ConfirmationPopup
							text={'The allocation for Share of Business has to be 100% for the Shortlisted Transporters before issuing the LOI. Please allocate 100% Share of Business and issue an LOI'}
							onCancel={this.state.isLoiApprover ? this.postLOIForApprover : this.loiPopupDetails}
						/>
					}
					{
						this.state.showLOIApproverRemarks && 
						<ConfirmationPopup
							text={"Enter the Remarks"}
							hasRemarks={true}
							onCancel={this.onCancelLOIApproverRemarksPopup}
							placeholder={'Remarks'}
							loiRejectionReason={this.state.sendLoiForApproverRemarks}
							onChangeLoiRejectionRemarks={(e) => {
								this.setState({
									sendLoiForApproverRemarks: e.target.value
								})
							}}
							remarksMandatory={true}
							onConfirm={this.postLOIForApprover}
						/>
					}
					{
					this.state.isDPHPopup && 
						<DPHUpdate
							dph={this.state.dph}
							onChangeDPH={this.onChangeDPH}
							focusedInput={this.state.focusedInput}
							onFocusChange={focusedInput => this.setState({ focusedInput: true ? focusedInput : null })}
							onCancel={this.closeUpdateDPHPopup}
							onSave={this.updateDPH}
							isCargil={CARGIL.includes(user.companyId)}
							companyId={user.companyId}
						/>
					}
					{
						this.state.extendContractTenure && 
						<ExtendContrcatTenure
							onChange={this.onChangeCT}
							CTData={this.state.CTData}
							onCancel={this.onCloseExtendCT}
							onSave={this.onSaveExtendCT}
							focusedInput={this.state.focusedECTInput}
                			onFocusChange={focusedInput => this.setState({ focusedECTInput: true ? focusedInput : null })}
						/>
					}
					{
						this.state.updateBusinessVolume && (
							<UpdateBusinessVolume
								businessVolumes={this.props.businessVolumes} 
								businessVolume={this.state.businessVolume}
								onChange={this.onChangeBusinessVolume}
								onSaveBusinessVolume={this.onSaveBusinessVolume}
								onCancel={this.onCloseUpdateBusinessVolume}
							/>
						)
					}
					{
						this.state.rfqTollUpdatePrice &&
						<RfqTollUpdatePrice
							is_rfq_toll_price_update={rfq?.is_rfq_toll_price_update}
							is_rfq_price_update={rfq?.is_rfq_price_update}
							onSave={this.onSaveExtendCT}
							onCancel={this.onCloseRfqTollUpdatePrice}
							rfq={rfq}
							CTData={this.state.CTData}
							focusedInput={this.state.focusedECTInput}
							onFocusChange={focusedInput => this.setState({ focusedECTInput: true ? focusedInput : null })}
							getSeekerBids={this.getSeekerBids}
							selectedTrip={this.state.selectedTrip}
						/>
					}
					{
						this.state.showPRPopup && 
						<PRDetailsPopup
							data={this.state.PRData} 
							onCancel={() => { this.setState({ showPRPopup: false }) }}
							onDownloadPRDetails={this.onDownloadPRDetails}
							isTransporter={this.state.isTransporter}
						/>
					}
					{
						this.state.showConfirmationPopup && 
						<LoiConfirmationPopup
							onCancel={() => {
								if(BEAM.includes(getUser().companyId)) {
									this.setState({
										loi_remarks: '',
										loi_docs: [],
										showConfirmationPopup: false
									})
								} else {
									if(this.state.isSendForApprover) {
										this.sendLOIForApprover();
									} else {
										this.showLoiPopup();
									}
								}
							}}
							text={this.getLOIPopUPText()}
							value={this.state.loi_remarks}
							onChange={(e) => this.setState({
								loi_remarks: e.target.value
							})}
							onSave={this.state.isSendForApprover ? () => this.sendLOIForApprover('save') : this.showLoiPopup}
							onUploadLoiDocs={this.onUploadLoiDocs}
							downloadUploadedFile={this.downloadUploadedFile}
							deleteDoc={this.deleteDoc}
							loi_docs={this.state.loi_docs}
						/>

					}
					{
						this.state.openStatusVisibilityPopup && 
							<UpdateStatusVisibility
								vendorBiddingStatus={vendorBiddingStatus || []}
								data={this.state.vendorBiddingStatusObj || {}}
								onChange={(option) => {
									const { vendorBiddingStatusObj } = this.state;
									vendorBiddingStatusObj['vendor_bidding_screen_id'] = option.id;
									vendorBiddingStatusObj['vendor_bidding_screen'] = option.name;
									this.setState({
										vendorBiddingStatusObj
									})
								}}
								onCancel={this.onCancelStatusVisibilityPopup}
								onSave={this.onSaveStatusVisibilityPopup}
							/>
					}
					{this.state.openPreBidPopup && 
						<PreBidPopup
							value={this.state.pre_bid_rfq_number}
							onChange={(e) => {
								const { value } = e.target;
								this.setState({
									pre_bid_rfq_number: value
								});
							}}
							onSave={this.saveConvertToPreBid}
							onCancel={this.onCancelConvertToPreBid}
						/>
					}
					{
						this.state.viewUploadedFiles && 
							<ViewUploadedFiles
								onCancel={() => this.setState({ viewUploadedFiles: false })}
								data={rfq && rfq.loi_document || []}
								downloadUploadedFile={this.downloadUploadedFile}
							/>
					}
					{this.state.addTransporters && this.props.groups && this.props.groups.length > 0 &&
						<Overlay>
						<div className="z-100 box-shadow pf t-0 col-1 bg-white pv-10 ht-40 border-bottom-theme">
							<Heading 
								text={'Transporters'} 
								className="tCenter"/>
							<CancelIcon onClick={this.onCancelTransporterModel} className="wt-15 ht-15 theme-fill pa curP mt-10 t-0 r-0 mr-5" />
						</div>
						<div className="flex pv-10 ph-20 mb-20 min-ht-250 t-20 mt-30 overflowAuto min-wt-250 max-wt-900 max-ht-700">
							{/* {(transporters || []).map(transGroup => ( */}
								{/* <div className="mr-10 wt-250"> */}
								{this.state.addTransporters && <TransportersCard
									viewMode={this.viewMode}
									searchGroupsAndTransporters={this.searchGroupsAndTransporters}
									transporters={this.props.transporters}
									rfq={rfq}
									groups={this.props.groups || []}
									// submitted={this.state.transporterDetailsSubmitted}
									alreadyExistTransporters={rfq.transporterIds || []}
									setGroups={(data) => {
										const { setTransporters } = this.state;
										setTransporters.setGroups(data);
									}}
								/>}
								{/* </div> */}
							{/* ))} */}
						</div>
						<div className="z-100 box-shadow pl-40 pv-10 pf col-1 bg-white">
							<button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20 fRight" onClick={this.onSaveTransporters}>Save</button>
							<button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20 fRight" onClick={this.onCancelTransporterModel}>Cancel</button>
						</div>
						</Overlay>
					}
				</Sticky>
			</div>
		)
	}
}


const mapStateToProps = ({ constants, rfq, contracting, common }) => {
	return {
		rfq: rfq.seekerBids.data,
		vehicleTypes: constants.vehicleTypes || [],
		vehicleBodyTypes: constants.vehicleBodyTypes || [],
		tripsCount: rfq.seekerBids.tripsCount,
		trips: rfq.seekerBids.trips,
		loadingTrips: rfq.seekerBids.dataLoading,
		challengePriceSubmitting: contracting.challengePrice.dataSubmitting,
		sendLoiSubmitting: contracting.sendLoi.dataSubmitting,
		uploadingBiddingDetails: contracting.uploadBiddingDetails.dataSubmitting,
		downloadingBiddingDetails: contracting.downloadBiddingDetails.dataSubmitting,


		paymentCycles: constants.paymentCycles || [],
		businessVolumes: constants.businessVolumes || [],
		pricingBasis: constants.pricingBasis || [],
		slabs: constants.slabs || [],

		systemTime: common.systemTime,
		sendLOIForApprover: contracting.sendLOIForApprover.dataSubmitting,
		downloadBidTrailDetails :contracting.downloadBidTrailDetails.dataSubmitting,
		tripBids: rfq.tripBids,
		courierZones: constants.courierZones || [],
		courierMovements: constants.courierMovements || [],
		courierModes: constants.courierModes || [],
		slabList: rfq.seekerBids.slabList || [],
		transporterBidCCharges: rfq.transporterBidCCharges,
		maxTransportersCountRFQ: rfq.seekerBids.maxTransportersCountRFQ || 0,
		currencyDetails: constants.currencyDetails || [],
		fromZones: rfq.seekerBids.fromZones || [],
		toZones: rfq.seekerBids.toZones || [],
		downloadBidRate : contracting.downloadBidRate.dataSubmitting,
		uploadBidRate : contracting.uploadBidRate.dataSubmitting,
		downloadTruckDetails : contracting.downloadTruckDetails.dataSubmitting,
		uploadTrucksDetails : contracting.uploadTrucksDetails.dataSubmitting,
		numberOfVehiclePlaced : contracting.numberOfVehiclePlaced.dataSubmitting,
		currencyTypes: constants.currencyTypes || [],
		loiCancelled : contracting.loiCancelled.dataSubmitting,
		bided_transporter_name: rfq.seekerBids.bided_transporter_name || [],
		groups: constants.groups || [],
      	transporters: ((constants.transporters || []).length > 0 && constants.transporters) || contracting.transportersList.data || [],
		vendorBiddingStatus: constants.vendorBiddingStatus || [],
		chat_menu: rfq.seekerBids.chat_menu,
		selectedNavBranch: constants.selectedNavBranch || {},
	}
};	


export default connect(mapStateToProps)(RFQBids);

function getTrips(trips = []) {
	const updatedData = trips.map((eleTR) => {
		const newEleTR = { ...eleTR }
		// orderText logic start here
		const bids = []
		eleTR.bids.forEach((eleB) => {
			const orderText = +eleB.orderText.split('').filter((ele) => ele !== 'L').join("")
			bids[(orderText - 1)] = eleB
		})
		for (let indOfBid = 0; indOfBid < bids.length; indOfBid++) {
			const bidEle = bids[indOfBid];
			if (!!!bidEle) {
				bids[indOfBid] = {
					orderText: `L${indOfBid + 1}`,
					isDummyObj: true
				}
			} else {
				bids[indOfBid] = bidEle
			}
		}
		newEleTR.bids = bids
		// orderText logic end here
		return newEleTR
	})
	return updatedData
}
